// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:32:43.331Z
// Property: Stone Creek at The Woodlands (ID: 5700260269654016)
// Collections: 25 amenities, 11 floorplans (live), 32 photos, 82 POIs, 4 reviews, 1 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5700260269654016",
  "property_external_id": "4770447",
  "property_zillow_url": "https://www.zillow.com/homedetails/3600-College-Park-Dr-APT-3302-The-Woodlands-TX-77384/2087827704_zpid/",
  "property_apartments_url": "https://www.apartments.com/stone-creek-at-the-woodlands-the-woodlands-tx/dbpzh4h",
  "property_google_business_url": "https://www.google.com/maps/place/Stone+Creek+at+The+Woodlands/@30.2073252,-95.4762976,17z/data=!4m13!1m7!3m6!1s0x864737ec1f8a0aa7:0x9101bf56cac435ab!2s3600+College+Park+Dr+Apt+1208,+The+Woodlands,+TX+77384!3b1!8m2!3d30.2073252!4d-95.4741036!3m4!1s0x8647374a6b6a6753:0xb96efc512315840a!8m2!3d30.207647!4d-95.473936",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443276571",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "stone-creek-at-the-woodlands",
  "property_name": "Stone Creek at The Woodlands",
  "property_website_url": "https://www.stonecreekwoodlands.com/",
  "property_domain": "https://www.stonecreekwoodlands.com/",
  "property_address": "3600 College Park Dr",
  "property_full_address": "3600 College Park Dr, The Woodlands, TX 77384",
  "property_address_1": "3600 College Park Dr",
  "property_address_2": null,
  "property_address_city": "The Woodlands",
  "property_address_state": "TX",
  "property_address_zip_full": "77384-4592",
  "property_address_zip": "77384",
  "property_address_country": "US",
  "property_address_county": "Montgomery County",
  "property_neighborhood_address": "College Park",
  "property_address_latitude": "30.2075598",
  "property_address_longitude": "-95.4741767",
  "property_email": "stonecreek@alapts.com",
  "property_phone": "(936) 321-0300",
  "property_call_tracking_phone": "281-972-2718",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Polished apartment living in The Woodlands’ College Park area.</strong> Explore one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with modern kitchens, granite countertops, in-home laundry, and easy access to resort-inspired spaces—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Stone Creek at The Woodlands.</p>",
  "property_long_description": "<p><strong>Polished apartment living in The Woodlands’ College Park area.</strong> At Stone Creek at The Woodlands, you can settle into a one-, two-, or three-bedroom layout with everyday upgrades like modern chef’s kitchens, granite countertops, stainless steel appliances, in-home washer/dryer, oversized closets, and a private patio, balcony, or solarium in select homes.</p><p>Beyond your front door, the community is built for easy downtime, with a beach-entry <a href=\"/amenities\">resort-inspired pool</a>, poolside summer kitchen, 24-hour fitness center with cycling studio, movie theater, coffee bar lounge, bark park, package concierge, covered parking, garages, and controlled access.</p><p>From College Park Drive, you’re close to I-45, College Park Village, Lone Star College–Montgomery, and The Woodlands’ signature destinations—The Woodlands Mall, Market Street, The Waterway, Hughes Landing, and Cynthia Woods Mitchell Pavilion. Explore nearby parks, pathways, dining, and entertainment, then come home to a quieter wooded setting with <a href=\"/floor-plans\">floor plans</a> designed around comfort and convenience.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019d02f1-195a-726c-ace5-fedfabd96b8f.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with a dark gray sofa, two cream accent chairs, a coffee table, and modern art.",
    "public_id": "019d02f1-195a-726c-ace5-fedfabd96b8f",
    "storage_key": "property/5700260269654016/019d02f1-195a-726c-ace5-fedfabd96b8f.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "240",
  "property_year_built": "2005",
  "property_year_renovated": "2021",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "91.66666666666666",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $300 / pet\nMonthly Pet Rent $25 / pet\nApplication Approval Fee Starting At $300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8642429.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://stonecreekatthewoodlands.loftliving.com/login",
  "property_apply_now_url": "https://8642429.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e702a-9e2e-73c3-a1d4-5a1b167d9239.webp",
  "property_primary_logo_media": {
    "alt_text": "Stone Creek at The Woodlands Premier Apartments logo.",
    "public_id": "019e702a-9e2e-73c3-a1d4-5a1b167d9239",
    "storage_key": "property/5700260269654016/019e702a-9e2e-73c3-a1d4-5a1b167d9239.webp",
    "width": 1482,
    "height": 843
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e702a-9e5e-75f9-9c09-51145611540a.webp",
  "property_secondary_logo_media": {
    "alt_text": "Stone Creek at The Woodlands logo with the tagline Premier Apartments.",
    "public_id": "019e702a-9e5e-75f9-9c09-51145611540a",
    "storage_key": "property/5700260269654016/019e702a-9e5e-75f9-9c09-51145611540a.webp",
    "width": 1482,
    "height": 843
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e702a-9e25-7483-9034-a2cd1235a41e.webp",
  "property_icon_media": {
    "alt_text": "Riverwalk logo",
    "public_id": "019e702a-9e25-7483-9034-a2cd1235a41e",
    "storage_key": "property/5700260269654016/019e702a-9e25-7483-9034-a2cd1235a41e.webp",
    "width": 384,
    "height": 384
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e702a-9e25-7483-9034-a2cd1235a41e.webp",
  "property_fav_icon_media": {
    "alt_text": "Riverwalk logo",
    "public_id": "019e702a-9e25-7483-9034-a2cd1235a41e",
    "storage_key": "property/5700260269654016/019e702a-9e25-7483-9034-a2cd1235a41e.webp",
    "width": 384,
    "height": 384
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e702a-9dee-764b-be3e-07ee82f154db.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Stone Creek at The Woodlands Premier Apartments logo",
    "public_id": "019e702a-9dee-764b-be3e-07ee82f154db",
    "storage_key": "property/5700260269654016/019e702a-9dee-764b-be3e-07ee82f154db.webp",
    "width": 1482,
    "height": 843
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f4355-8a2e-717d-8e18-22c1ce66b1f3.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f4355-8a2e-717d-8e18-22c1ce66b1f3",
    "storage_key": "property/5700260269654016/019f4355-8a2e-717d-8e18-22c1ce66b1f3.webp",
    "width": 1280,
    "height": 728
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#00537a",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#006c97",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "580 - 1386",
  "property_sqft_min": "580",
  "property_sqft_max": "1386",
  "property_price_range": "1160 - 2029",
  "property_price_min": "1160",
  "property_price_max": "2029",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/StoneCreekatTheWoodlands",
  "property_instagram_url": "https://www.instagram.com/StoneCreekAtTheWoodlands",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJU2dqa0o3R4YRCoQVI1H8brk",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/stone-creek-at-the-woodlands-the-woodlands",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Everyday comfort, standout spaces.</strong> Stone Creek at The Woodlands brings resort-inspired ease to your routine with a beach-entry pool, poolside summer kitchen, 24-hour fitness center with cycling studio, half basketball court, movie theater, and coffee bar lounge. Inside, polished finishes like granite countertops, stainless steel appliances, oversized closets, and in-home washers and dryers keep each day streamlined.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room to live well.</strong> Explore one-, two-, and three-bedroom apartments at Stone Creek at The Woodlands, with open, polished interiors and practical space for every day. Granite countertops, stainless steel appliances, wood-style flooring, oversized closets, in-home washer and dryer, and 9-foot ceilings with crown molding add the finish. Select homes offer built-in desks, oval garden tubs, and a private patio, balcony, or solarium.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview the polished details.</strong> Browse photos of Stone Creek at The Woodlands, from sunlit living rooms with patios, balconies, or solariums to granite kitchens with stainless steel appliances and tile backsplash. Then step outside to see the beach-entry pool, poolside summer kitchen, coffee bar lounge, fitness center, movie theater, basketball court, bark park, and shaded seating areas waiting throughout the community.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Map out more than a commute.</strong> Stone Creek at The Woodlands places College Park convenience near wooded trails, everyday shopping, Market Street patio dining, Waterway nights, and Town Center energy. With I-45 close by and the Town Center Trolley connecting key dining, retail, hotel, and entertainment stops, it’s easy to keep the week moving—and come home to controlled-access comfort when the day winds down.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to love at Stone Creek at The Woodlands.</strong><br>Reviews call out a clean, well-kept setting, responsive office and maintenance teams, friendly neighbors, and cozy renovated homes. Community favorites include the fitness room, pool area, movie theater, sports court, and dog park—plus a peaceful, smaller-community feel with easy access to The Woodlands, Conroe, and Magnolia. Read what makes everyday life here feel like “a real treat.”</p>",
  "property_neighborhood_blurb": "<p><strong>Start with the map, then picture the day around it.</strong> From Stone Creek at The Woodlands, College Park puts you close to wooded pathways, everyday shopping, and a Town Center scene that moves from patio dining at Market Street to concerts and nights along The Waterway. When you want more room to roam, The Woodlands’ park system and trail network make green space feel woven into the week—not saved for a getaway. Commuting and exploring stay straightforward, too, with I-45 nearby and the Town Center Trolley connecting major shopping, dining, hotel, and entertainment stops. After you’ve explored the neighborhood, come back to a controlled-access community with spaces made for unwinding; see more on the <a href=\"/amenities\">amenities page</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Refresh, recharge, and make the everyday easier.</strong> At Stone Creek at The Woodlands, amenities are designed to add comfort before, during, and after your day—from a beach-entry pool with a poolside summer kitchen to a 24-hour fitness center with cycling studio, half basketball court, movie theater, and coffee bar lounge. Your apartment keeps the same polished feel with a modern chef’s kitchen, granite countertops, stainless steel appliances, in-home washer and dryer, oversized closets, and options like built-in desks, garden tubs, USB outlets, or a patio, balcony, or solarium in select homes. Browse the <a href=\"/gallery\">photo gallery</a>, then explore the details that make daily living feel more streamlined, relaxed, and ready for what’s next.</p>",
  "property_applynow_blurb": "<p><strong>Start your application for polished apartment living in The Woodlands.</strong> Choose a one-, two-, or three-bedroom home with modern finishes, in-home convenience, and comfortable space to settle in. Apply online today and move one step closer to Stone Creek at The Woodlands.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact the Stone Creek at The Woodlands leasing team for help with apartment details, availability, and getting here from College Park Drive. Ready to see more? Explore our <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> today.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Stone Creek at The Woodlands?</strong> Start here for quick answers about the community, leasing, apartment features, and everyday living in the College Park area. If you don’t see what you need, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the layout that fits your day.</strong> Stone Creek at The Woodlands offers one-, two-, and three-bedroom apartments with options that feel open, practical, and polished—from efficient one-bedroom homes to larger two- and three-bedroom layouts with room to spread out.</p><p>As you compare availability, look for details that make each floor plan feel finished: <a href=\"/amenities\">granite countertops</a>, stainless steel appliances, wood-style flooring, oversized closets, in-home washer and dryer, and 9-foot ceilings with crown molding. Select homes add thoughtful extras like built-in computer desks, oval garden tubs, and a private patio, balcony, or solarium, giving you more ways to shape your space. Browse current floor plans, check pricing, and find the apartment that feels like the right next step.</p>",
  "property_gallery_blurb": "<p><strong>See the spaces before you step inside.</strong> Browse the Stone Creek at The Woodlands photo gallery for a closer look at the finishes, gathering areas, and outdoor moments that give the community its polished feel. Picture sunlit living rooms opening to patios, balconies, or solariums; kitchens with sleek granite, stainless steel appliances, and tile backsplash; and bedrooms with space to settle in and stay organized.</p><p>Outside, the images move from the beach-entry pool and poolside summer kitchen to the coffee bar lounge, fitness center, movie theater, basketball court, bark park, and shaded seating areas. As you explore each photo, you can start to connect the everyday details with the bigger picture—then compare <a href=\"/floor-plans\">available layouts</a>, explore more <a href=\"/amenities\">community features</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Stone Creek on the map.</strong> See available <a href=\"/floor-plans\">one-, two-, and three-bedroom apartments</a> in The Woodlands’ College Park area, then scan the nearby parks, pathways, dining, entertainment, and I-45 access that surround this quieter wooded setting.</p>",
  "property_pets_blurb": "<p><strong>A home base for paws, whiskers, and everyday walks.</strong> At Stone Creek at The Woodlands, your cat or dog can settle in comfortably with pet-friendly apartment layouts, private patios or balconies in select homes, and no weight limit for approved pets. When it’s time to burn off energy, head to the on-site <a href=\"/amenities\">Bark Park</a>, loop through the controlled-access community, or make a quick plan for a shaded outing around The Woodlands’ dog-friendly parks and trails.</p><p>Back at home, conveniences like in-home washers and dryers, oversized closets, package services, and on-site maintenance help keep routines simple—so walks, play breaks, and quiet evenings can fit naturally into your day. Have questions about pet fees, limits, or breed guidelines? <a href=\"/contact-us\">Contact the leasing team</a> before you apply.</p>",
  "property_referafriend_blurb": "<p><strong>Share polished living in College Park.</strong> Love the modern kitchens, spacious layouts, wooded setting, and easy downtime at Stone Creek at The Woodlands? Invite a friend to explore our <a href=\"/floor-plans\">one-, two-, and three-bedroom homes</a> and see what makes this community feel so easy to recommend.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Stone Creek at The Woodlands.</strong><br>Handle rent payments, maintenance requests, and account details in one convenient place—then get back to polished apartment living with the comfort, convenience, and everyday ease that define your College Park home.</p>",
  "property_reviews_blurb": "<p><strong>See why residents recommend Stone Creek at The Woodlands.</strong><br>In the reviews below, you’ll notice the same themes again and again: a clean, well-kept community, friendly neighbors, and an office and maintenance team described as helpful, respectful, and quick to respond. Residents also highlight thoughtful updates, cozy renovated homes, and community spaces that make everyday downtime easy—from the fitness room and pool area to the movie theater, sports court, and dog park.</p><p>Many reviews point to the welcoming feel of this smaller, peaceful apartment community and the convenient connection to The Woodlands, Conroe, and Magnolia areas. As one resident put it, the team and setting “make staying here a real treat.” Browse real feedback from people who call Stone Creek home.</p>",
  "property_created_at": "1752256549813",
  "property_scheduletour_blurb": "<p><strong>See polished College Park living up close.</strong> Tour Stone Creek at The Woodlands and picture the details in person—from chef-inspired kitchens with granite and stainless steel to oversized closets and relaxing outdoor spaces in select homes. Schedule your visit today and find the layout that fits your everyday rhythm.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will follow up soon. In the meantime, picture polished apartment living in The Woodlands’ College Park area, with modern chef’s kitchens, granite countertops, in-home washer/dryer, and relaxing community spaces designed for easy everyday comfort.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through the highlights before you arrive.</strong> Start with two community virtual tours that let you get a feel for Stone Creek at The Woodlands from anywhere, then step inside the two-bedroom, two-bath apartment tour to see how the layout flows in real time. Move from room to room at your own pace, noticing the polished kitchen finishes, open living areas, bedroom separation, closet space, and the indoor-outdoor connection created by a patio, balcony, or solarium in select homes. The community tours add context, giving you a closer look at the spaces that shape daily life beyond your front door. When you’re ready, compare <a href=\"/floor-plans\">available layouts</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see more in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Stone Creek at The Woodlands",
  "property_seo_title_home": "Stone Creek at The Woodlands | Apartments in The Woodlands, TX",
  "property_seo_description_home": "Experience luxury living at Stone Creek at The Woodlands in The Woodlands, TX! Choose from a variety of thoughtfully designed floor plans, including one-, two-, and three-bedroom apartments. Dive into exclusive amenities like a beach-entry swimming pool, state-of-the-art fitness center, dog park, and more. Enjoy modern comforts with chef's kitchens, walk-in closets, and convenient online resident services. Explore our community and discover your perfect home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in The Woodlands, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at Stone Creek at The Woodlands, TX! Explore our diverse floor plans featuring one, two, and three-bedroom options tailored to meet your needs. Browse our available apartment homes today and find the perfect floor plan that fits your lifestyle. Experience comfort and convenience in a vibrant community!",
  "property_seo_title_amenities": "Amenities | The Woodlands, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover luxury living at Stone Creek at The Woodlands in TX! Explore spacious one, two, and three-bedroom floor plans featuring exceptional amenities like a chef’s kitchen, outdoor kitchen, and a beach-entry swimming pool. Enjoy access to a fitness center, dog park, and a relaxing coffee bar. Our community also offers covered parking, online resident services, and a theatre room. Experience comfort and style with features like crown molding and walk-in closets. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in The Woodlands, TX",
  "property_seo_description_gallery": "\"Explore the vibrant photo gallery of Stone Creek at The Woodlands, TX, where modern living meets exceptional amenities! Discover our spacious one, two, and three-bedroom floor plans featuring chef’s kitchens, walk-in closets, and garden tubs. Enjoy exclusive access to our fitness center, basketball court, and beach-entry swimming pools. Picture yourself here with online resident services, a dog park, and a relaxing coffee bar. Your dream apartment awaits—view all our stunning images and envision your new lifestyle today!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Stone Creek at The Woodlands Apartments",
  "property_seo_description_virtualtours": "Discover your perfect home at Stone Creek at The Woodlands! Explore our stunning one, two, and three-bedroom floor plans in The Woodlands, TX. Take a virtual tour of our vibrant community and beautifully designed apartments for rent. Experience the lifestyle you've been dreaming of—start your journey today!",
  "property_seo_title_interactivemap": "Interactive Map | Stone Creek at The Woodlands Apartments",
  "property_seo_description_interactivemap": "Discover your dream apartment at Stone Creek at The Woodlands, TX! Explore our spacious one, two, and three-bedroom floor plans featuring top-notch amenities like access gates, a fitness center, beach-entry swimming pools, and a dog park. Experience modern living with chef’s kitchens, built-in desks, and walk-in closets. Ready to find your ideal home? Use our interactive community map to search available apartments, view pricing, and make Stone Creek your next residence today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in The Woodlands, TX",
  "property_seo_description_neighborhood": "Discover the vibrant community surrounding Stone Creek at The Woodlands, TX! Explore our diverse floor plans—one, two, and three-bedroom apartments—while uncovering local favorites and nearby attractions. See what's around our community and elevate your living experience today!",
  "property_seo_title_contact": "Contact Us | Stone Creek at The Woodlands",
  "property_seo_description_contact": "Discover your perfect home at Stone Creek at The Woodlands, TX! Choose from our spacious one, two, and three-bedroom floor plans designed for comfort and style. Need assistance? Have questions? Contact our leasing team today to find out more about your ideal living space!",
  "property_seo_title_faqs": "FAQs | Apartments in The Woodlands, TX",
  "property_seo_description_faqs": "Discover everything you need to know about Stone Creek at The Woodlands, your ideal apartment community in The Woodlands, TX. Explore our one, two, and three-bedroom floor plans, featuring top-notch amenities like a state-of-the-art fitness center, beach-entry swimming pools, and a chef's kitchen. Have questions? Browse our FAQs page for answers about our luxury living experience, including details on access gates, the dog park, covered parking, and more. Join us at Stone Creek at The Woodlands and elevate your lifestyle today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in The Woodlands, TX",
  "property_seo_description_reviews": "Discover the vibrant lifestyle at Stone Creek at The Woodlands, TX! Explore our thoughtfully designed one, two, and three-bedroom floor plans, complete with luxurious amenities like a chef's kitchen, fitness center, and beach-entry swimming pools. Enjoy access to our dog park, outdoor kitchen, and theatre room, all in a secure, gated community. Don't just take our word for it—see what our residents say about their experience living here! Join us at Stone Creek and elevate your apartment living today!",
  "property_seo_title_applynow": "Apply Now | Apartments in The Woodlands, TX",
  "property_seo_description_applynow": "Discover your perfect home at Stone Creek at The Woodlands in beautiful The Woodlands, TX! Choose from spacious floor plans featuring one, two, and three-bedroom layouts. Enjoy luxurious amenities such as a fitness center, beach-entry swimming pools, a chef’s kitchen, and a dog park. With access gates, covered parking, and online resident services, convenience is at your fingertips. Explore our community's vibrant social spaces, including an outdoor kitchen and theatre room. Don't wait—apply now and lease your new home today!",
  "property_seo_title_residentaccess": "Resident Access | Stone Creek at The Woodlands",
  "property_seo_description_residentaccess": "\"Welcome to Stone Creek at The Woodlands! Log in to your resident portal for easy rent payments, maintenance requests, and community updates. Experience seamless living in The Woodlands, TX. Access now!\"",
  "property_seo_title_referafriend": "Refer A Friend | Stone Creek at The Woodlands",
  "property_seo_description_referafriend": "\"Invite your friends to the vibrant Stone Creek at The Woodlands community in The Woodlands, TX! Great friends make great neighbors—refer a friend today and discover the perks of living in our welcoming apartments. Enjoy modern amenities, a friendly atmosphere, and a referral bonus waiting for you!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Stone Creek at The Woodlands",
  "property_seo_description_scheduletour": "Explore Stone Creek at The Woodlands, where luxury meets comfort in the heart of The Woodlands, TX. Schedule a tour of our vibrant community today and discover your future home!",
  "property_seo_title_privacy": "Privacy Policy | Stone Creek at The Woodlands",
  "property_seo_description_privacy": "Discover how Stone Creek at The Woodlands values your privacy and protects your personal information. Read our comprehensive Privacy Policy to learn more about our commitment to security and transparency. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Stone Creek at The Woodlands",
  "property_seo_description_accessibility": "\"Discover Stone Creek at The Woodlands, where we prioritize digital inclusion and accessibility for all. Explore our commitment to providing an inclusive living experience in The Woodlands, TX. Learn more about our accessibility initiatives today!\"",
  "property_seo_title_sitemap": "Sitemap | Stone Creek at The Woodlands",
  "property_seo_description_sitemap": "Discover the comprehensive sitemap for Stone Creek at The Woodlands in The Woodlands, TX. Explore our community amenities, floor plans, and services effortlessly. Navigate your way to your ideal apartment home today—view our website sitemap!",
  "property_seo_title_thankyou": "Thank You | Stone Creek at The Woodlands",
  "property_seo_description_thankyou": "\"Thank you for reaching out to Stone Creek at The Woodlands! We're excited to assist you in your apartment search. A member of our dedicated team will contact you shortly to provide personalized information about our beautiful community in The Woodlands, TX. Stay tuned!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Summerville, SC\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320260",
  "amenities": [
    {
      "id": "custom_8b08703f-8470-4882-8556-d29972806776",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Controlled Access Community",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b3fbf8a0-d87f-4d4e-b98c-b02ce19f6a95",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_09286ae4-5d6b-49df-9a4c-7849ed5e4385",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000605",
      "title": "Built-In Desk",
      "amount": "0.0000",
      "description": "Built-In Computer Desks",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_07852bab-6375-4c3f-b133-45bd5d202ea6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000613",
      "title": "Chef`s Kitchen",
      "amount": "0.0000",
      "description": "Modern Chefs Kitchen",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_98319b68-8f0b-4fce-b960-e1ec88b3e2c3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000615",
      "title": "Coffee Bar",
      "amount": "0.0000",
      "description": "Resident Lounge w/Coffee Bar",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a1a8546b-33d4-4543-9194-5852130e0975",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_615897df-adb2-427b-abd7-ada7bf1d32ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000623",
      "title": "Covered Parking",
      "amount": "0.0000",
      "description": "Covered Parking Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_420735dc-6c0c-48a9-bcda-a2a454fb6c8b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000624",
      "title": "Crown Molding",
      "amount": "0.0000",
      "description": "9' Ceilings w/ Crown Molding",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4ad5f0a4-99e6-45fe-b922-84f6a0b9777f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ae54e4b1-fe12-474d-aaba-27efb1f96b75",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "24-Hour Modern Fitness Center w/Cycling Studio",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3453553b-d503-4287-a7a1-bfecd6e344a1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000640",
      "title": "Garages",
      "amount": "0.0000",
      "description": "Garage Parking Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_18cb18fa-05e2-4415-bd48-f6640486eed4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000641",
      "title": "Garden Tub",
      "amount": "0.0000",
      "description": "Oval Garden Tubs",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7b0f95d5-a3cc-488e-9218-635ae585dfec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e859240c-7bba-4e61-9ebf-c1a1dc4ac717",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d18903f1-a9eb-472f-bdc3-16e0719353ff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dc9a9db2-19a3-4f8f-ae54-19ea875305ed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000662",
      "title": "Outdoor Kitchen",
      "amount": "0.0000",
      "description": "Community Poolside Summer Kitchen",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_34381b61-ede0-4ec3-bf3e-0b6197553b2d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c650857-f6be-40c4-ad51-b4d5be163579",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000665",
      "title": "Package System",
      "amount": "0.0000",
      "description": "Resident Concierge Package System",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_861b08ee-d1d1-4c36-8fd9-23904fededf4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f8ed2339-946e-41c8-b129-f3a3bda9642f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000693",
      "title": "Theatre Room",
      "amount": "0.0000",
      "description": "Movie Theater",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_08fc0e99-731c-4265-b3c2-0dc4632b16e2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bbe14303-85e3-41f0-b370-4e852bf40734",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "USB Outlets*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_35327186-737c-46ac-9bb2-411053c1ab4d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "Private Patio, Balcony or Solarium",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_14358b71-0289-4c7b-acfb-9445ae592790",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Oversized Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ed718f59-7a13-4693-8660-0f1782e7c1a6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "external_id": "P000000771",
      "title": "Beach-Entry Swimming Pools",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool w/ Beach Entry",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_cb8e8a6e-5bd4-4e02-9c86-e70b84bf3bd8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-9e90-7378-8970-fda64958fdc8.webp",
      "image_media": {
        "alt_text": "Cozy bedroom featuring a king-size bed with white linens and decorative pillows, a dark blue accent wall with artwork and mirrors, and a large window with white curtains.",
        "public_id": "019e89b0-9e90-7378-8970-fda64958fdc8",
        "storage_key": "property/5700260269654016/019e89b0-9e90-7378-8970-fda64958fdc8.webp",
        "width": 2632,
        "height": 1756
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom. Featuring plush bedding, tasteful decor, and ample natural light, it's the perfect sanctuary.",
      "link": "",
      "alt_text": "Cozy bedroom featuring a king-size bed with white linens and decorative pillows, a dark blue accent wall with artwork and mirrors, and a large window with white curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e4e94baf-d1b6-40a1-a862-c19b53e58418",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-9581-7268-9bbc-659231c463a7.webp",
      "image_media": {
        "alt_text": "Modern living room with dark gray sofa, cream accent chairs, coffee table, and bar seating.",
        "public_id": "019e89b0-9581-7268-9bbc-659231c463a7",
        "storage_key": "property/5700260269654016/019e89b0-9581-7268-9bbc-659231c463a7.webp",
        "width": 2668,
        "height": 1778
      },
      "title": "Apartment",
      "description": "Step into this beautifully furnished living room, complete with a cozy sofa, accent chairs, and a convenient breakfast bar, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Modern living room with dark gray sofa, cream accent chairs, coffee table, and bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4bcc0e97-641b-47f0-9723-b9dff77b53a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-94a6-77af-9993-8339267393bb.webp",
      "image_media": {
        "alt_text": "Stone Creek at The Woodlands Premier Apartments monument sign with stone pillars and landscaping.",
        "public_id": "019e89b0-94a6-77af-9993-8339267393bb",
        "storage_key": "property/5700260269654016/019e89b0-94a6-77af-9993-8339267393bb.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Welcome to Stone Creek at The Woodlands, offering premier apartment living. This monument sign features the property name and address.",
      "link": "",
      "alt_text": "Stone Creek at The Woodlands Premier Apartments monument sign with stone pillars and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8efff5a1-a6bf-470f-bdef-d7454c0cf820",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-89c1-75ad-91e7-ab259704c80c.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019e89b0-89c1-75ad-91e7-ab259704c80c",
        "storage_key": "property/5700260269654016/019e89b0-89c1-75ad-91e7-ab259704c80c.webp",
        "width": 2673,
        "height": 1782
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded umbrellas. Perfect for soaking up the sun or enjoying a refreshing dip.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_393508c7-075a-40aa-980b-5147adfc2085",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-89f6-7396-9c79-53c5fe4c5599.webp",
      "image_media": {
        "alt_text": "Open concept living area with a modern kitchen featuring gray cabinets, a breakfast bar with stools, and stainless steel appliances.",
        "public_id": "019e89b0-89f6-7396-9c79-53c5fe4c5599",
        "storage_key": "property/5700260269654016/019e89b0-89f6-7396-9c79-53c5fe4c5599.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Enjoy this open-concept living space, seamlessly connecting your living area to a modern kitchen equipped with sleek gray cabinetry, a convenient breakfast bar with seating, and stylish stainless steel appliances.",
      "link": "",
      "alt_text": "Open concept living area with a modern kitchen featuring gray cabinets, a breakfast bar with stools, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_48e03cd3-028e-4dbc-bb47-f4a98923a8eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-8bb1-717a-ad7c-9b6aab6c5c75.webp",
      "image_media": {
        "alt_text": "Home theater with reclining leather chairs and a projector screen.",
        "public_id": "019e89b0-8bb1-717a-ad7c-9b6aab6c5c75",
        "storage_key": "property/5700260269654016/019e89b0-8bb1-717a-ad7c-9b6aab6c5c75.webp",
        "width": 2596,
        "height": 1732
      },
      "title": "Community",
      "description": "Enjoy movie nights in the community's private home theater, complete with plush reclining seats and a large projection screen for an immersive cinematic experience.",
      "link": "",
      "alt_text": "Home theater with reclining leather chairs and a projector screen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_99795e30-d106-4b51-b4c9-1782c070f74b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-88f9-73c5-93c8-9d2101fa0912.webp",
      "image_media": {
        "alt_text": "Luxurious communal lounge area with a large stone fireplace, comfortable seating, and a modern chandelier.",
        "public_id": "019e89b0-88f9-73c5-93c8-9d2101fa0912",
        "storage_key": "property/5700260269654016/019e89b0-88f9-73c5-93c8-9d2101fa0912.webp",
        "width": 2552,
        "height": 1702
      },
      "title": "Community",
      "description": "Unwind in our beautifully appointed communal lounge, featuring a grand stone fireplace, plush seating, and elegant decor, perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Luxurious communal lounge area with a large stone fireplace, comfortable seating, and a modern chandelier.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ea0a208d-7e45-42e6-b4a4-1335ac289957",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-8726-72dc-ab01-be01a7734d64.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with blue upholstered furniture and stone accent walls.",
        "public_id": "019e89b0-8726-72dc-ab01-be01a7734d64",
        "storage_key": "property/5700260269654016/019e89b0-8726-72dc-ab01-be01a7734d64.webp",
        "width": 2371,
        "height": 1581
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge area, featuring comfortable seating and a modern design perfect for socializing or quiet enjoyment.",
      "link": "",
      "alt_text": "Outdoor lounge area with blue upholstered furniture and stone accent walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9546b3d5-db34-445e-a490-09a6c04e3414",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-877b-7768-ad21-e55bb3e68c7e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019e89b0-877b-7768-ad21-e55bb3e68c7e",
        "storage_key": "property/5700260269654016/019e89b0-877b-7768-ad21-e55bb3e68c7e.webp",
        "width": 2662,
        "height": 1775
      },
      "title": "Apartment",
      "description": "Step into this stylish bathroom featuring a granite-top vanity, a clean toilet, and a bathtub with an eye-catching shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_acfc8fca-5969-4864-afbe-9377ca200325",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-85f7-77c4-9a13-2b1b10cf7d34.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, granite countertops, stainless steel appliances, and decorative plants.",
        "public_id": "019e89b0-85f7-77c4-9a13-2b1b10cf7d34",
        "storage_key": "property/5700260269654016/019e89b0-85f7-77c4-9a13-2b1b10cf7d34.webp",
        "width": 2516,
        "height": 1678
      },
      "title": "Apartment",
      "description": "Showcasing a stylish apartment kitchen featuring sleek gray cabinetry, elegant granite countertops, and a full suite of modern stainless steel appliances. Perfect for home chefs!",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets, granite countertops, stainless steel appliances, and decorative plants.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6490ecaf-260c-48fa-94e1-efb70bb4b691",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-8783-747f-a1e9-75802e5ed3bc.webp",
      "image_media": {
        "alt_text": "Indoor basketball court with a hoop and the Stone Creek Premier Apartments logo on the wall.",
        "public_id": "019e89b0-8783-747f-a1e9-75802e5ed3bc",
        "storage_key": "property/5700260269654016/019e89b0-8783-747f-a1e9-75802e5ed3bc.webp",
        "width": 2484,
        "height": 1656
      },
      "title": "Community",
      "description": "Shoot hoops on our indoor basketball court, a perfect amenity for active residents at Stone Creek Premier Apartments.",
      "link": "",
      "alt_text": "Indoor basketball court with a hoop and the Stone Creek Premier Apartments logo on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fe31cb9f-fb0d-4d1d-b1f9-8aa411c36f75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-8084-7105-bc6e-81d5c12a1efe.webp",
      "image_media": {
        "alt_text": "A home office setup with a desk, chair, and wall shelves.",
        "public_id": "019e89b0-8084-7105-bc6e-81d5c12a1efe",
        "storage_key": "property/5700260269654016/019e89b0-8084-7105-bc6e-81d5c12a1efe.webp",
        "width": 2343,
        "height": 1562
      },
      "title": "Apartment",
      "description": "Create your perfect workspace in this cozy home office nook, complete with a stylish desk and ample shelving for organization.",
      "link": "",
      "alt_text": "A home office setup with a desk, chair, and wall shelves.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9a9d4f29-52e1-4c83-a75e-40769a4ad159",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-7dae-74aa-bf2a-bbf6c930db82.webp",
      "image_media": {
        "alt_text": "Community gathering area with coffee bar and seating",
        "public_id": "019e89b0-7dae-74aa-bf2a-bbf6c930db82",
        "storage_key": "property/5700260269654016/019e89b0-7dae-74aa-bf2a-bbf6c930db82.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and a place to gather in this comfortable community space.",
      "link": "",
      "alt_text": "Community gathering area with coffee bar and seating",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0421b6f9-42b0-44a5-ac28-f85e173748b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-7881-7695-86df-8bf3fe653c61.webp",
      "image_media": {
        "alt_text": "Living room and kitchen with breakfast bar and bar stools.",
        "public_id": "019e89b0-7881-7695-86df-8bf3fe653c61",
        "storage_key": "property/5700260269654016/019e89b0-7881-7695-86df-8bf3fe653c61.webp",
        "width": 2627,
        "height": 1751
      },
      "title": "Apartment",
      "description": "Spacious living area flows into a modern kitchen with a breakfast bar, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen with breakfast bar and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0fe48af8-fff0-4047-a1b5-443a3778d650",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-6c9d-74ab-b875-37fd753dbbfd.webp",
      "image_media": {
        "alt_text": "King size bed with blue accent wall and modern decor, leading to a walk-in closet and en-suite bathroom.",
        "public_id": "019e89b0-6c9d-74ab-b875-37fd753dbbfd",
        "storage_key": "property/5700260269654016/019e89b0-6c9d-74ab-b875-37fd753dbbfd.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Relax in style in this spacious bedroom, complete with a plush king-size bed, ample closet space, and a private en-suite bathroom.",
      "link": "",
      "alt_text": "King size bed with blue accent wall and modern decor, leading to a walk-in closet and en-suite bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_edb44655-94f7-4fd0-a747-0952a926aa56",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-65f6-70ff-ad6b-925fe8829739.webp",
      "image_media": {
        "alt_text": "Spacious and elegantly decorated community lounge with a large stone fireplace, comfortable seating, and a dramatic chandelier.",
        "public_id": "019e89b0-65f6-70ff-ad6b-925fe8829739",
        "storage_key": "property/5700260269654016/019e89b0-65f6-70ff-ad6b-925fe8829739.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring a cozy stone fireplace and ample seating for socializing or quiet enjoyment.",
      "link": "",
      "alt_text": "Spacious and elegantly decorated community lounge with a large stone fireplace, comfortable seating, and a dramatic chandelier.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f90eb372-abf1-452a-a8ca-ed120708be03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-719f-726d-b4de-f730ce5330bc.webp",
      "image_media": {
        "alt_text": "Spin bikes in a fitness room with a TV showing a cycling class.",
        "public_id": "019e89b0-719f-726d-b4de-f730ce5330bc",
        "storage_key": "property/5700260269654016/019e89b0-719f-726d-b4de-f730ce5330bc.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring spin bikes and virtual fitness classes.",
      "link": "",
      "alt_text": "Spin bikes in a fitness room with a TV showing a cycling class.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e47ca0c5-a1b3-4df2-9278-7bd876037c3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-65bb-76f9-b690-ecd937499380.webp",
      "image_media": {
        "alt_text": "Living room with couch, chairs, coffee table, and artwork.",
        "public_id": "019e89b0-65bb-76f9-b690-ecd937499380",
        "storage_key": "property/5700260269654016/019e89b0-65bb-76f9-b690-ecd937499380.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a dark gray sofa, accent chairs, a modern coffee table, and abstract wall art. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with couch, chairs, coffee table, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cf59cba1-29ea-41c3-aaea-f6c99a0634c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-6536-708c-8f9c-6cdb9f71146b.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with outdoor seating and grilling area",
        "public_id": "019e89b0-6536-708c-8f9c-6cdb9f71146b",
        "storage_key": "property/5700260269654016/019e89b0-6536-708c-8f9c-6cdb9f71146b.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy outdoor living with this community's well-appointed grilling station and seating area, perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "Exterior view of apartment building with outdoor seating and grilling area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0ef7b9fd-6f3d-45bc-abec-4d3aade2e649",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-678b-777b-9a86-603a878ac89f.webp",
      "image_media": {
        "alt_text": "Modern living room with a TV displaying the Stone Creek at The Woodlands logo.",
        "public_id": "019e89b0-678b-777b-9a86-603a878ac89f",
        "storage_key": "property/5700260269654016/019e89b0-678b-777b-9a86-603a878ac89f.webp",
        "width": 2649,
        "height": 1766
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a TV, comfortable seating, and a dedicated workspace, perfect for relaxation and productivity.",
      "link": "",
      "alt_text": "Modern living room with a TV displaying the Stone Creek at The Woodlands logo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f4db8934-5040-47d1-92fd-44e6c6c75d7e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-6518-77da-b86d-5020aa713ea1.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with cardio machines, weight machines, and free weights.",
        "public_id": "019e89b0-6518-77da-b86d-5020aa713ea1",
        "storage_key": "property/5700260269654016/019e89b0-6518-77da-b86d-5020aa713ea1.webp",
        "width": 2631,
        "height": 1754
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide selection of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Well-equipped fitness center with cardio machines, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_16a94972-a02d-4c16-b825-d5513367b9c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-68b3-756d-a939-ce1d8dd07698.webp",
      "image_media": {
        "alt_text": "Elegant community lounge with stone fireplace, comfortable seating, and modern decor.",
        "public_id": "019e89b0-68b3-756d-a939-ce1d8dd07698",
        "storage_key": "property/5700260269654016/019e89b0-68b3-756d-a939-ce1d8dd07698.webp",
        "width": 2585,
        "height": 1723
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring a beautiful stone fireplace and chic seating areas, perfect for socializing or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Elegant community lounge with stone fireplace, comfortable seating, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0d62a5c6-f843-48df-ba50-bda71fb834ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-6538-75cd-889f-bef0dae7649e.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e89b0-6538-75cd-889f-bef0dae7649e",
        "storage_key": "property/5700260269654016/019e89b0-6538-75cd-889f-bef0dae7649e.webp",
        "width": 2681,
        "height": 1788
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the pool in our resort-style outdoor swimming area, complete with comfortable lounge chairs and shaded umbrellas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_570b5f17-1aa6-4867-970e-34d12556c26f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-6590-7712-ac67-47a1432bbb76.webp",
      "image_media": {
        "alt_text": "Bedroom with a king size bed, dresser, mirror, and window.",
        "public_id": "019e89b0-6590-7712-ac67-47a1432bbb76",
        "storage_key": "property/5700260269654016/019e89b0-6590-7712-ac67-47a1432bbb76.webp",
        "width": 2652,
        "height": 1768
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a plush king-size bed, a dark wood dresser with a long mirror, and a large window with white curtains.",
      "link": "",
      "alt_text": "Bedroom with a king size bed, dresser, mirror, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_008a9380-a869-4a30-9795-96c78cb57e62",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-5901-763c-9b3b-31c45ac19223.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019e89b0-5901-763c-9b3b-31c45ac19223",
        "storage_key": "property/5700260269654016/019e89b0-5901-763c-9b3b-31c45ac19223.webp",
        "width": 2681,
        "height": 1788
      },
      "title": "Community",
      "description": "Enjoy our sparkling swimming pool, perfect for relaxing and soaking up the sun. Surrounded by comfortable lounge chairs and shaded umbrellas, it's the ideal spot to unwind.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_014b70ce-a3cd-44d1-a3da-3c8c951e9161",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-59bc-709c-b968-17aaa2afb4fe.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019e89b0-59bc-709c-b968-17aaa2afb4fe",
        "storage_key": "property/5700260269654016/019e89b0-59bc-709c-b968-17aaa2afb4fe.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Discover your ideal living space in this stylish kitchen, featuring sleek gray cabinetry, granite countertops, and modern stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d5d1d0af-2ed2-4e20-92fb-552d2aa79280",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-5416-772d-90bf-4aaeef4a91df.webp",
      "image_media": {
        "alt_text": "Spacious walk-in closet with white shelving and hanging rods.",
        "public_id": "019e89b0-5416-772d-90bf-4aaeef4a91df",
        "storage_key": "property/5700260269654016/019e89b0-5416-772d-90bf-4aaeef4a91df.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Organize your belongings in style with this spacious walk-in closet, featuring ample shelving and hanging space.",
      "link": "",
      "alt_text": "Spacious walk-in closet with white shelving and hanging rods.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b28be412-dda9-4266-947f-70eabc90b044",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-452d-751c-b2b9-d1986085340d.webp",
      "image_media": {
        "alt_text": "Laundry room with washer, dryer, and water heater.",
        "public_id": "019e89b0-452d-751c-b2b9-d1986085340d",
        "storage_key": "property/5700260269654016/019e89b0-452d-751c-b2b9-d1986085340d.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry with a washer, dryer, and ample shelving for storage. Includes a water heater.",
      "link": "",
      "alt_text": "Laundry room with washer, dryer, and water heater.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ed4db14a-c1ab-4e81-b7cb-6e42a0e94289",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-4770-7027-9c02-fbc8953e785b.webp",
      "image_media": {
        "alt_text": "View of a basketball court through a glass wall, with a hallway and bench to the left.",
        "public_id": "019e89b0-4770-7027-9c02-fbc8953e785b",
        "storage_key": "property/5700260269654016/019e89b0-4770-7027-9c02-fbc8953e785b.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy active living with our on-site sport court, perfect for a friendly game of basketball or other court sports. Amenities include a gym and more.",
      "link": "",
      "alt_text": "View of a basketball court through a glass wall, with a hallway and bench to the left.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_76e9013d-d887-4f75-9b79-0d41b45144f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-3a95-76ec-ba50-4440e2331e83.webp",
      "image_media": {
        "alt_text": "Luxury apartment community lounge with fireplace, seating, and TV displaying property logo.",
        "public_id": "019e89b0-3a95-76ec-ba50-4440e2331e83",
        "storage_key": "property/5700260269654016/019e89b0-3a95-76ec-ba50-4440e2331e83.webp",
        "width": 2636,
        "height": 1757
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed community lounge, featuring a cozy fireplace, comfortable seating areas, and a large television for your entertainment. Enjoy the sophisticated ambiance.",
      "link": "",
      "alt_text": "Luxury apartment community lounge with fireplace, seating, and TV displaying property logo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f9655575-fd3d-452c-97d6-65716ef6860e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-3c20-71e8-bbc4-292bf08f5987.webp",
      "image_media": {
        "alt_text": "Secure package lockers with the Stone Creek at the Woodlands logo.",
        "public_id": "019e89b0-3c20-71e8-bbc4-292bf08f5987",
        "storage_key": "property/5700260269654016/019e89b0-3c20-71e8-bbc4-292bf08f5987.webp",
        "width": 2427,
        "height": 1618
      },
      "title": "Community",
      "description": "Convenient and secure package lockers are available for residents at Stone Creek at the Woodlands, offering a safe place to receive deliveries.",
      "link": "",
      "alt_text": "Secure package lockers with the Stone Creek at the Woodlands logo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fef141ea-a72a-4a32-b35a-efe8b9cfbb77",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e89b0-3b4b-735f-a031-50bfad377520.webp",
      "image_media": {
        "alt_text": "Gather sign, Starbucks sign, and wall decor in a community area.",
        "public_id": "019e89b0-3b4b-735f-a031-50bfad377520",
        "storage_key": "property/5700260269654016/019e89b0-3b4b-735f-a031-50bfad377520.webp",
        "width": 2662,
        "height": 1774
      },
      "title": "Community",
      "description": "Stylish community area featuring a 'gather' sign, Starbucks branding, and modern art, perfect for resident interaction.",
      "link": "",
      "alt_text": "Gather sign, Starbucks sign, and wall decor in a community area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_9b10d9a5d7b9fb773e420c2f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Nona's Italian Grill - The Woodlands",
      "poi_type": "Restaurants",
      "poi_address": "3091 College Park Dr #185, The Woodlands, TX 77384, USA",
      "poi_short_description": "This casual Italian eatery with a snug bar serves familiar red-sauce fare in a modest dining room.",
      "poi_long_description": "This casual Italian eatery with a snug bar serves familiar red-sauce fare in a modest dining room.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-03c0-762c-80ff-aec611c76053.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-03c0-762c-80ff-aec611c76053",
        "storage_key": "property/5700260269654016/019f14fc-03c0-762c-80ff-aec611c76053.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://nonasitaliangrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3997367643524095788&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nonas-italian-grill---the-woodlands",
      "poi_latitude": "30.2050585",
      "poi_longitude": "-95.4632962",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 936-224-3132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef6b-7596-a578-5a055fd5195b",
        "storage_key": "property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk1kUwjg3R4YRLN_kXLGAeTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_8d10875ff0c1b209e2ce0049",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Triple Pepper 川三椒 The Woodlands",
      "poi_type": "Restaurants",
      "poi_address": "3091 College Park Dr #170, The Woodlands, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-0925-71e9-aa36-47d085fb30ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-0925-71e9-aa36-47d085fb30ad",
        "storage_key": "property/5700260269654016/019f14fc-0925-71e9-aa36-47d085fb30ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://triplepeppertx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12899605099958382202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "triple-pepper--the-woodlands",
      "poi_latitude": "30.2050585",
      "poi_longitude": "-95.4632962",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 936-224-5152",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef6b-7596-a578-5a055fd5195b",
        "storage_key": "property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOabhtM83R4YRei7WTX6aBLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_a65bd2bde311d845b769e9f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "JAX Burgers, Fries & Shakes",
      "poi_type": "Restaurants",
      "poi_address": "8821 Metropark Dr Ste 1600, Shenandoah, TX 77385, USA",
      "poi_short_description": "Casual hamburger joint dishing up comfort food such as cheeseburgers, fries, and shakes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-0225-7036-a09f-6264c4ae5e18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-0225-7036-a09f-6264c4ae5e18",
        "storage_key": "property/5700260269654016/019f14fc-0225-7036-a09f-6264c4ae5e18.webp",
        "width": 1132,
        "height": 1132
      },
      "poi_business_url": "http://jaxburgers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2291630401818895092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jax-burgers-fries--shakes",
      "poi_latitude": "30.1951959",
      "poi_longitude": "-95.451956",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 936-231-8648",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef6b-7596-a578-5a055fd5195b",
        "storage_key": "property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkRozZAc3R4YR9KLmeLWBzR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_53dafd6d3cfeb7a2f277a2eb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "3073 College Park Dr, The Woodlands, TX 77384, USA",
      "poi_short_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_long_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-0611-71b2-b7c8-a3abde059cb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-0611-71b2-b7c8-a3abde059cb9",
        "storage_key": "property/5700260269654016/019f14fc-0611-71b2-b7c8-a3abde059cb9.webp",
        "width": 1280,
        "height": 641
      },
      "poi_business_url": "https://locations.whataburger.com/tx/the-woodlands/3073-college-park-dr.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=9254451434624622635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "30.2064514",
      "poi_longitude": "-95.4619504",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 936-273-7724",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef6b-7596-a578-5a055fd5195b",
        "storage_key": "property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3wSrqkA3R4YRK6DnL4xqboA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_4a72a0a0533b1c3e138de657",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Bloofin Sushi & Bar - Woodlands",
      "poi_type": "Restaurants",
      "poi_address": "1900 Hughes Landing Blvd Ste D-300, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-022c-737a-8d81-01213b332f96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-022c-737a-8d81-01213b332f96",
        "storage_key": "property/5700260269654016/019f14fc-022c-737a-8d81-01213b332f96.webp",
        "width": 680,
        "height": 471
      },
      "poi_business_url": "https://bloofinsushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2522787174150559579&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bloofin-sushi--bar---woodlands",
      "poi_latitude": "30.1708327",
      "poi_longitude": "-95.4714303",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 346-261-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef6b-7596-a578-5a055fd5195b",
        "storage_key": "property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTE3JqM3R4YRW9cnj5G9AiM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_c6b510cca39503390836477c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Truluck's Ocean's Finest Seafood and Crab",
      "poi_type": "Restaurants",
      "poi_address": "1900 Hughes Landing Blvd Suite 600, The Woodlands, TX 77380, USA",
      "poi_short_description": "Upscale seafood & steak chain featuring half-price happy hours, a deep wine list & swanky surrounds.",
      "poi_long_description": "Upscale seafood & steak chain featuring half-price happy hours, a deep wine list & swanky surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-03b3-720d-b06f-916ed8001638.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-03b3-720d-b06f-916ed8001638",
        "storage_key": "property/5700260269654016/019f14fc-03b3-720d-b06f-916ed8001638.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://trulucks.com/locations/houston-woodlands-texas",
      "poi_directions_map_url": "https://maps.google.com/?cid=8600764676808325174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trulucks-oceans-finest-seafood-and-crab",
      "poi_latitude": "30.1712634",
      "poi_longitude": "-95.4722029",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-465-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef6b-7596-a578-5a055fd5195b",
        "storage_key": "property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_WWgCM42R4YRNjjjnecNXHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_43369c635b6e694f17899c11",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Sixty Vines The Woodlands",
      "poi_type": "Restaurants",
      "poi_address": "9595 Six Pines Dr Ste 900, The Woodlands, TX 77380, USA",
      "poi_short_description": "Casual New American kitchen & wine bar offering bites & wines on tap in spacious, modern surrounds.",
      "poi_long_description": "Casual New American kitchen & wine bar offering bites & wines on tap in spacious, modern surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-0996-7239-89e3-4b4d9be106e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-0996-7239-89e3-4b4d9be106e6",
        "storage_key": "property/5700260269654016/019f14fc-0996-7239-89e3-4b4d9be106e6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4913649263050803371&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sixty-vines-the-woodlands",
      "poi_latitude": "30.1638394",
      "poi_longitude": "-95.4639382",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 346-478-5360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef6b-7596-a578-5a055fd5195b",
        "storage_key": "property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLQ9Gvq83R4YRq8gAm_jJMEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_40a1b6a8be45b4006407d723",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Postino Woodlands",
      "poi_type": "Restaurants",
      "poi_address": "2025 Hughes Landing Blvd Ste 1100, The Woodlands, TX 77381, USA",
      "poi_short_description": "Wine bar and restaurant serving panini, bruschetta, and other small plates, plus dessert.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-03ce-70d0-93ac-2ca8d0d111bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-03ce-70d0-93ac-2ca8d0d111bb",
        "storage_key": "property/5700260269654016/019f14fc-03ce-70d0-93ac-2ca8d0d111bb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.postino.com/locations/postino-woodlands",
      "poi_directions_map_url": "https://maps.google.com/?cid=2362038426453034193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "postino-woodlands",
      "poi_latitude": "30.1689579",
      "poi_longitude": "-95.4717677",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-825-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef6b-7596-a578-5a055fd5195b",
        "storage_key": "property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJla4aPOo3R4YR0USOKm-lxyA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_abfad4deb162a07403f14e55",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Fogo de Chão Brazilian Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "1900 Hughes Landing Blvd #400, The Woodlands, TX 77380, USA",
      "poi_short_description": "Upscale Brazilian chain for all-you-can-eat meat carved tableside plus an extensive salad bar.",
      "poi_long_description": "Upscale Brazilian chain for all-you-can-eat meat carved tableside plus an extensive salad bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-06eb-773d-988c-979843be3631.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-06eb-773d-988c-979843be3631",
        "storage_key": "property/5700260269654016/019f14fc-06eb-773d-988c-979843be3631.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fogodechao.com/location/the-woodlands/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9840275276965230370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fogo-de-cho-brazilian-steakhouse",
      "poi_latitude": "30.1711577",
      "poi_longitude": "-95.4716466",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-298-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef6b-7596-a578-5a055fd5195b",
        "storage_key": "property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkRwzN842R4YRIjeSdzquj4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brazilian_restaurant"
    },
    {
      "id": "ec_e865807bec8f11ce352f0030",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "TRIS",
      "poi_type": "Restaurants",
      "poi_address": "24 Waterway Ave #125, The Woodlands, TX 77380, USA",
      "poi_short_description": "Contemporary, white-tablecloth venue serving New American fare, with an intimate chef's table.",
      "poi_long_description": "Contemporary, white-tablecloth venue serving New American fare, with an intimate chef's table.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-093d-7210-9a5b-d0594cd51b6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-093d-7210-9a5b-d0594cd51b6a",
        "storage_key": "property/5700260269654016/019f14fc-093d-7210-9a5b-d0594cd51b6a.webp",
        "width": 1280,
        "height": 869
      },
      "poi_business_url": "https://triswoodlands.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14804666738331105403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tris",
      "poi_latitude": "30.1610442",
      "poi_longitude": "-95.4589017",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-203-5641",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef6b-7596-a578-5a055fd5195b",
        "storage_key": "property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzQK1j782R4YRezhExPW9dM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_8af7682ea53c5729fbe6c2ea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "The Refuge Bar & Bistro",
      "poi_type": "Restaurants",
      "poi_address": "24 Waterway Ave #110, The Woodlands, TX 77380, USA",
      "poi_short_description": "Specialty cocktails, beer, wine & creative flatbreads served in a cozy, vintage-inspired space.",
      "poi_long_description": "Specialty cocktails, beer, wine & creative flatbreads served in a cozy, vintage-inspired space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-0f24-71ae-8fe6-350547ed0f7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-0f24-71ae-8fe6-350547ed0f7a",
        "storage_key": "property/5700260269654016/019f14fc-0f24-71ae-8fe6-350547ed0f7a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.refugeinthewoodlands.com/bar-bistro/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15170539654820305654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-refuge-bar--bistro",
      "poi_latitude": "30.1609125",
      "poi_longitude": "-95.4589383",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 713-389-5674",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-c72e-7387-aeb1-ecfe6f9df735.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-c72e-7387-aeb1-ecfe6f9df735",
        "storage_key": "property/5700260269654016/019f14fc-c72e-7387-aeb1-ecfe6f9df735.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT244ib82R4YR9pqKaHCViNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_c6c991b9fefbaac3c56b6960",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "The Toasted Yolk Cafe",
      "poi_type": "Restaurants",
      "poi_address": "207 E Shore Dr #100, The Woodlands, TX 77380, USA",
      "poi_short_description": "Relaxed, counter-serve eatery featuring a menu of breakfast and brunch dishes and a full bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-0f33-7739-8867-e7831c833fca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-0f33-7739-8867-e7831c833fca",
        "storage_key": "property/5700260269654016/019f14fc-0f33-7739-8867-e7831c833fca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thetoastedyolk.com/locations/the-woodlands/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17354181229561586660&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-toasted-yolk-cafe",
      "poi_latitude": "30.15826479999999",
      "poi_longitude": "-95.4729975",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 832-844-3991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef6b-7596-a578-5a055fd5195b",
        "storage_key": "property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJET3fSIc3R4YR5CPFw-Fv1vA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_3804cdae0e5cade4298e930a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Whiskey Cake Kitchen & Bar",
      "poi_type": "Restaurants",
      "poi_address": "27800 Interstate 45 N, Oak Ridge North, TX 77385, USA",
      "poi_short_description": "Farm-to-table eatery serves burgers, pizzas, steak frites, and whiskey cake made from area ingredients in warm digs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-11c4-728d-92cb-c166074ecb19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-11c4-728d-92cb-c166074ecb19",
        "storage_key": "property/5700260269654016/019f14fc-11c4-728d-92cb-c166074ecb19.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.whiskeycake.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15073247606305138820&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whiskey-cake-kitchen--bar",
      "poi_latitude": "30.16467699999999",
      "poi_longitude": "-95.4496469",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 346-209-5577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef6b-7596-a578-5a055fd5195b",
        "storage_key": "property/5700260269654016/019f14f9-ef6b-7596-a578-5a055fd5195b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKwvk6Fw3R4YRhChTIdbuLtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_dcc550b174e89f23c9478089",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "3040 College Park Dr, The Woodlands, TX 77384, USA",
      "poi_short_description": "Department store offering groceries, clothing, home goods, furniture, electronics, and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-10ad-773a-a56c-42a37e1f6c05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-10ad-773a-a56c-42a37e1f6c05",
        "storage_key": "property/5700260269654016/019f14fc-10ad-773a-a56c-42a37e1f6c05.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/3213-the-woodlands-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9207573024026914084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "30.209771",
      "poi_longitude": "-95.4599252",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 936-321-9922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef61-739d-9cec-5e97f45cf4fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef61-739d-9cec-5e97f45cf4fd",
        "storage_key": "property/5700260269654016/019f14f9-ef61-739d-9cec-5e97f45cf4fd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJRR1HVUA3R4YRJO2XrOHex38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_5a7640275b95ce7f3b10023d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "3061 College Park Dr, Conroe, TX 77384, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-13d0-7231-b5b1-8abc3f485f2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-13d0-7231-b5b1-8abc3f485f2f",
        "storage_key": "property/5700260269654016/019f14fc-13d0-7231-b5b1-8abc3f485f2f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3061+college+park+dr-conroe-tx-77384/id=7632",
      "poi_directions_map_url": "https://maps.google.com/?cid=13727632404078478088&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "30.2062972",
      "poi_longitude": "-95.4612093",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 936-271-9471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoVOtWj83R4YRCEM9fPBYgr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_73987cde726d7159d1efc758",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "3601 FM 1488, The Woodlands, TX 77384, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-130d-70ce-95e3-fa638f7c881a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-130d-70ce-95e3-fa638f7c881a",
        "storage_key": "property/5700260269654016/019f14fc-130d-70ce-95e3-fa638f7c881a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/the-woodlands/north-woodlands-market-h-e-b-638?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=1135747683568357691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "30.225988",
      "poi_longitude": "-95.519313",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 936-271-2730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef64-724b-b532-f2340ec8290a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef64-724b-b532-f2340ec8290a",
        "storage_key": "property/5700260269654016/019f14f9-ef64-724b-b532-f2340ec8290a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO3UxFuQ5R4YRO5GQMYD8wg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_c4fa47bcedc35c418870a2f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Timewise",
      "poi_type": "Shopping & Retail",
      "poi_address": "4105 College Park Dr, The Woodlands, TX 77384, USA",
      "poi_short_description": "Chain of gas stations with convenience stores, selling snacks, drinks & sundries.",
      "poi_long_description": "Chain of gas stations with convenience stores, selling snacks, drinks & sundries.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://find.shell.com/us/fuel/10004983-4105-college-park-dr/en_US",
      "poi_directions_map_url": "https://maps.google.com/?cid=11495900287613255822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "timewise",
      "poi_latitude": "30.204071",
      "poi_longitude": "-95.481053",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 936-321-9305",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-c77a-70cc-9844-0ffef0fa9995.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-c77a-70cc-9844-0ffef0fa9995",
        "storage_key": "property/5700260269654016/019f14fc-c77a-70cc-9844-0ffef0fa9995.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJc48AUMowR4YRjsB_WGekiZ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_3a61c10752d3e7e6176eae48",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Windvale Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "9420 College Park Dr, Conroe, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-135d-73ad-92c4-26a8ab41b928.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-135d-73ad-92c4-26a8ab41b928",
        "storage_key": "property/5700260269654016/019f14fc-135d-73ad-92c4-26a8ab41b928.webp",
        "width": 1000,
        "height": 563
      },
      "poi_business_url": "https://brixmor.com/leasing/retail-space/tx/conroe/windvale-center?utm_source=gmb&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=776102791561313855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "windvale-center",
      "poi_latitude": "30.22846849999999",
      "poi_longitude": "-95.5092317",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 610-215-7939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef61-739d-9cec-5e97f45cf4fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef61-739d-9cec-5e97f45cf4fd",
        "storage_key": "property/5700260269654016/019f14f9-ef61-739d-9cec-5e97f45cf4fd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0dKeB3g6R4YRP34zgGBFxQo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_f8d9b7395c312dc40e3d453b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1100 Lake Woodlands Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-15b1-759c-9867-54c17e3dcda1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-15b1-759c-9867-54c17e3dcda1",
        "storage_key": "property/5700260269654016/019f14fc-15b1-759c-9867-54c17e3dcda1.webp",
        "width": 1280,
        "height": 957
      },
      "poi_business_url": "https://www.target.com/sl/woodlands/684",
      "poi_directions_map_url": "https://maps.google.com/?cid=12474043558932355254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "30.169777",
      "poi_longitude": "-95.4530464",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-364-1281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef61-739d-9cec-5e97f45cf4fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef61-739d-9cec-5e97f45cf4fd",
        "storage_key": "property/5700260269654016/019f14f9-ef61-739d-9cec-5e97f45cf4fd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJt6S0Gek2R4YRtpjpyoa0HK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_1cbb13c6934c7764dcd86894",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "The Woodlands Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "1201 Lake Woodlands Dr #700, The Woodlands, TX 77380, USA",
      "poi_short_description": "Plaza for shoe, toy, familiar apparel & jewelry shops, plus a kid play area, carousel & food court.",
      "poi_long_description": "Plaza for shoe, toy, familiar apparel & jewelry shops, plus a kid play area, carousel & food court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-a5f0-7021-8a14-75ad20849e08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-a5f0-7021-8a14-75ad20849e08",
        "storage_key": "property/5700260269654016/019f14f9-a5f0-7021-8a14-75ad20849e08.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thewoodlandsmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=8877476350304112571&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-woodlands-mall",
      "poi_latitude": "30.1643612",
      "poi_longitude": "-95.4539757",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-363-3363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef61-739d-9cec-5e97f45cf4fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef61-739d-9cec-5e97f45cf4fd",
        "storage_key": "property/5700260269654016/019f14f9-ef61-739d-9cec-5e97f45cf4fd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1_a7Zuo2R4YRu8_OqbQhM3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_201817233e4e92cc3b2c8bf9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Market Street",
      "poi_type": "Shopping & Retail",
      "poi_address": "9595 Six Pines Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "Trendy, mixed-use town center housing luxury retailers, upscale restaurants, bars & a movie theater.",
      "poi_long_description": "Trendy, mixed-use town center housing luxury retailers, upscale restaurants, bars & a movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-1626-731b-8ecb-b4a2fb03c033.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-1626-731b-8ecb-b4a2fb03c033",
        "storage_key": "property/5700260269654016/019f14fc-1626-731b-8ecb-b4a2fb03c033.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://shopatmarketstreet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10104591045945142808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "market-street",
      "poi_latitude": "30.1638371",
      "poi_longitude": "-95.4635036",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-419-4774",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef61-739d-9cec-5e97f45cf4fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef61-739d-9cec-5e97f45cf4fd",
        "storage_key": "property/5700260269654016/019f14f9-ef61-739d-9cec-5e97f45cf4fd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKVeL_8Y2R4YRGC4nFgW4Oow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_edb79a9c0192871c27209b90",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "8000 Research Forest Dr, The Woodlands, TX 77382, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-1619-7595-b961-12778c6443d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-1619-7595-b961-12778c6443d1",
        "storage_key": "property/5700260269654016/019f14fc-1619-7595-b961-12778c6443d1.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/the-woodlands/alden-bridge/034/00732?cid=loc_03400732_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5869019485025531596&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "30.2107458",
      "poi_longitude": "-95.5281031",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-419-1116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef64-724b-b532-f2340ec8290a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef64-724b-b532-f2340ec8290a",
        "storage_key": "property/5700260269654016/019f14f9-ef64-724b-b532-f2340ec8290a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx8g31GUwR4YRzPbKUCDyclE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_0964d5ac407590ec25c3c236",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "College Park Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "3040 College Park Dr, Conroe, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18184187153520046236&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "college-park-shopping-center",
      "poi_latitude": "30.211",
      "poi_longitude": "-95.459",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef61-739d-9cec-5e97f45cf4fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef61-739d-9cec-5e97f45cf4fd",
        "storage_key": "property/5700260269654016/019f14f9-ef61-739d-9cec-5e97f45cf4fd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJa_JxxRg3R4YRnLDIRt81W_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_5ca364dd5a02567e24be0d9e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "The Woodlands College Park High School",
      "poi_type": "Education",
      "poi_address": "3701 College Park Dr, The Woodlands, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-17af-7446-93f8-4e2cb58eabc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-17af-7446-93f8-4e2cb58eabc8",
        "storage_key": "property/5700260269654016/019f14fc-17af-7446-93f8-4e2cb58eabc8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://twcp.conroeisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10132254085328821925&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-woodlands-college-park-high-school",
      "poi_latitude": "30.2045668",
      "poi_longitude": "-95.4717587",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 936-709-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-efb9-74ef-9aa7-557cfa8cf35c",
        "storage_key": "property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzZH_VDU3R4YRpV4GWmj_nIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_455124a9887e15d636e3cfb0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Prescolaire Early Learning Academy",
      "poi_type": "Education",
      "poi_address": "3709 College Park Dr, The Woodlands, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-1931-75f8-8e9f-8a8d565174b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-1931-75f8-8e9f-8a8d565174b7",
        "storage_key": "property/5700260269654016/019f14fc-1931-75f8-8e9f-8a8d565174b7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.prescolaireus.com/index.php/locations?location=woodlands-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=5790998255166117795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prescolaire-early-learning-academy",
      "poi_latitude": "30.2056785",
      "poi_longitude": "-95.4740891",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 936-209-7657",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-efb9-74ef-9aa7-557cfa8cf35c",
        "storage_key": "property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0zBJ3rE3R4YRo1cVJjvCXVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_900107d39539e99492244c70",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "SHSU - The Woodlands Center",
      "poi_type": "Education",
      "poi_address": "3380 College Park Dr, The Woodlands, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-18c6-7699-9bd1-df2e03a4e13b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-18c6-7699-9bd1-df2e03a4e13b",
        "storage_key": "property/5700260269654016/019f14fc-18c6-7699-9bd1-df2e03a4e13b.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "http://www.shsu.edu/academics/woodlands-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1907815939368180908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shsu---the-woodlands-center",
      "poi_latitude": "30.2091764",
      "poi_longitude": "-95.4706137",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 936-202-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-efb9-74ef-9aa7-557cfa8cf35c",
        "storage_key": "property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI7NKr0k3R4YRrFzeIn3seRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_ee8c3b7f543c4aaa87b51b6c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Lone Star College Montgomery",
      "poi_type": "Education",
      "poi_address": "3200 College Park Dr, Conroe, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ae70-72a1-8815-652538043a15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-ae70-72a1-8815-652538043a15",
        "storage_key": "property/5700260269654016/019f14f9-ae70-72a1-8815-652538043a15.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.lonestar.edu/montgomery",
      "poi_directions_map_url": "https://maps.google.com/?cid=14910642082803884477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lone-star-college-montgomery",
      "poi_latitude": "30.2103106",
      "poi_longitude": "-95.4682838",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 936-273-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-efb9-74ef-9aa7-557cfa8cf35c",
        "storage_key": "property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7ZMdJEY3R4YRvSGEbvk97c4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_edf4ceff5ffc2db7f09dde23",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Knox Junior High School",
      "poi_type": "Education",
      "poi_address": "12104 Sawmill Rd, Spring, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://knox.conroeisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2341242613658048160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "knox-junior-high-school",
      "poi_latitude": "30.13136",
      "poi_longitude": "-95.4644948",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 832-592-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-efb9-74ef-9aa7-557cfa8cf35c",
        "storage_key": "property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf0KB0xw0R4YRoFYYsMDDfSA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_638d8d9b5f65b09226eb3e30",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Collins Intermediate",
      "poi_type": "Education",
      "poi_address": "6020 Shadowbend Pl, The Woodlands, TX 77381, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://collins.conroeisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15372239509453738592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "collins-intermediate",
      "poi_latitude": "30.18449549999999",
      "poi_longitude": "-95.4928434",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-298-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-efb9-74ef-9aa7-557cfa8cf35c",
        "storage_key": "property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEUs0LR4xR4YRYBI3Y2MqVdU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_006ed344a82d1988fe4e6cb8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "David Elementary School",
      "poi_type": "Education",
      "poi_address": "5301 Shadowbend Pl, The Woodlands, TX 77381, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-1bac-758e-8c27-bacf62383bf5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-1bac-758e-8c27-bacf62383bf5",
        "storage_key": "property/5700260269654016/019f14fc-1bac-758e-8c27-bacf62383bf5.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://david.conroeisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=696526986399660249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "david-elementary-school",
      "poi_latitude": "30.1786346",
      "poi_longitude": "-95.5032044",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-298-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-efb9-74ef-9aa7-557cfa8cf35c",
        "storage_key": "property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo_orkB4xR4YR2TjTkJqPqgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_f781e57a49797435fd17d77e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Sally K Ride Elementary",
      "poi_type": "Education",
      "poi_address": "4920 W Panther Creek Dr, Spring, TX 77381, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://ride.conroeisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15554956507143315795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sally-k-ride-elementary",
      "poi_latitude": "30.167624",
      "poi_longitude": "-95.4998138",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-465-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-efb9-74ef-9aa7-557cfa8cf35c",
        "storage_key": "property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7VZkLRYxR4YRU6HtkIdO3tc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_191e8f45d791ae585e5de909",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Primrose School of The Woodlands at College Park",
      "poi_type": "Education",
      "poi_address": "6403 College Park Dr, The Woodlands, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-1a07-7708-b5c5-151395441a7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-1a07-7708-b5c5-151395441a7d",
        "storage_key": "property/5700260269654016/019f14fc-1a07-7708-b5c5-151395441a7d.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.primroseschools.com/schools/woodlands-college-park/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=11972269560758510962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-the-woodlands-at-college-park",
      "poi_latitude": "30.2080062",
      "poi_longitude": "-95.5001217",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 936-321-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-efb9-74ef-9aa7-557cfa8cf35c",
        "storage_key": "property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJC7XICpUwR4YRcqU71LsLJqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_15a350f5e723c35524e98bb3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "The Woodlands Christian Academy",
      "poi_type": "Education",
      "poi_address": "5800 Academy Way, The Woodlands, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-211b-7529-b02e-25c30831ed7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-211b-7529-b02e-25c30831ed7b",
        "storage_key": "property/5700260269654016/019f14fc-211b-7529-b02e-25c30831ed7b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.twca.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11329397235969929608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-woodlands-christian-academy",
      "poi_latitude": "30.20529399999999",
      "poi_longitude": "-95.487703",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 936-273-2555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-efb9-74ef-9aa7-557cfa8cf35c",
        "storage_key": "property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPRkVBcgwR4YRiLFHqcIaOp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_8cc12a12d464442ce1baa4ff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "The Cynthia Woods Mitchell Pavilion",
      "poi_type": "Entertainment",
      "poi_address": "2005 Lake Robbins Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "Unique outdoor performance space surrounded by trees features live music, theater & dance shows.",
      "poi_long_description": "Unique outdoor performance space surrounded by trees features live music, theater & dance shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-1c5b-7513-93ee-12df5c698253.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-1c5b-7513-93ee-12df5c698253",
        "storage_key": "property/5700260269654016/019f14fc-1c5b-7513-93ee-12df5c698253.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.woodlandscenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9903810310770188732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-cynthia-woods-mitchell-pavilion",
      "poi_latitude": "30.1614265",
      "poi_longitude": "-95.4640655",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-364-3010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWcAcMc2R4YRvOFOSAFncYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "ec_06423e9e765ee3401c9f4a99",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Cinemark The Woodlands and XD",
      "poi_type": "Entertainment",
      "poi_address": "1600 Lake Robbins Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-1b8a-71e9-a0eb-91838c46465b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-1b8a-71e9-a0eb-91838c46465b",
        "storage_key": "property/5700260269654016/019f14fc-1b8a-71e9-a0eb-91838c46465b.webp",
        "width": 750,
        "height": 551
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-the-woodlands/cinemark-the-woodlands-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI5MjYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9733071841112520673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-the-woodlands-and-xd",
      "poi_latitude": "30.1620546",
      "poi_longitude": "-95.4586425",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-362-4340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-c761-7621-9e1a-5c29298ddb09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-c761-7621-9e1a-5c29298ddb09",
        "storage_key": "property/5700260269654016/019f14fc-c761-7621-9e1a-5c29298ddb09.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJW1FjesA2R4YR4XfefkXREoc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_52d20a1f1359f359507f1ce7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "The Woodlands Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "4775 W Panther Creek Dr #280, The Woodlands, TX 77381, USA",
      "poi_short_description": "Interactive exhibits & imaginative play are the focus of this museum designed for young children.",
      "poi_long_description": "Interactive exhibits & imaginative play are the focus of this museum designed for young children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ac78-7745-bdfe-063da04adf9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-ac78-7745-bdfe-063da04adf9d",
        "storage_key": "property/5700260269654016/019f14f9-ac78-7745-bdfe-063da04adf9d.webp",
        "width": 400,
        "height": 400
      },
      "poi_business_url": "http://woodlandschildrensmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1661874245600597207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-woodlands-childrens-museum",
      "poi_latitude": "30.167706",
      "poi_longitude": "-95.502756",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-465-0955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef5f-7119-b1e5-5ee28edf52da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef5f-7119-b1e5-5ee28edf52da",
        "storage_key": "property/5700260269654016/019f14f9-ef5f-7119-b1e5-5ee28edf52da.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJqcYNveo2R4YR19RkRtIpEBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_f30427267f3f8ce7a8c276d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Play Street Museum - The Woodlands",
      "poi_type": "Entertainment",
      "poi_address": "207 E Shore Dr #190, The Woodlands, TX 77380, USA",
      "poi_short_description": "Imagination-fueling space with colorful play areas designed for kids 8 and under.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-b670-724a-a74c-5ced214125de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-b670-724a-a74c-5ced214125de",
        "storage_key": "property/5700260269654016/019f14f9-b670-724a-a74c-5ced214125de.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://thewoodlands.playstreetmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=130721062280546155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "play-street-museum---the-woodlands",
      "poi_latitude": "30.158053",
      "poi_longitude": "-95.4723453",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 832-585-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef5f-7119-b1e5-5ee28edf52da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef5f-7119-b1e5-5ee28edf52da",
        "storage_key": "property/5700260269654016/019f14f9-ef5f-7119-b1e5-5ee28edf52da.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJaQvuMgs3R4YRa8fkER1q0AE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_0ebcb5f40951b3af5bec9546",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Riva Row Boat House",
      "poi_type": "Entertainment",
      "poi_address": "2101 Riva Row, The Woodlands, TX 77380, USA",
      "poi_short_description": "Lakeside park offering kayak, canoe, stand-up paddleboard, and pedal boat rentals.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-2dfb-765d-911a-bc16d0101a72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-2dfb-765d-911a-bc16d0101a72",
        "storage_key": "property/5700260269654016/019f14fc-2dfb-765d-911a-bc16d0101a72.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://rivarowboathouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17084086843900672828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riva-row-boat-house",
      "poi_latitude": "30.16001769999999",
      "poi_longitude": "-95.4665433",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-210-3965",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoWo7ELg2R4YRPLufGnjeFu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_9ea836802e0745d9cf2918c6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Market Street",
      "poi_type": "Entertainment",
      "poi_address": "9595 Six Pines Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "Trendy, mixed-use town center housing luxury retailers, upscale restaurants, bars & a movie theater.",
      "poi_long_description": "Trendy, mixed-use town center housing luxury retailers, upscale restaurants, bars & a movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-1626-731b-8ecb-b4a2fb03c033.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-1626-731b-8ecb-b4a2fb03c033",
        "storage_key": "property/5700260269654016/019f14fc-1626-731b-8ecb-b4a2fb03c033.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://shopatmarketstreet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10104591045945142808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "market-street",
      "poi_latitude": "30.1638371",
      "poi_longitude": "-95.4635036",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-419-4774",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef61-739d-9cec-5e97f45cf4fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef61-739d-9cec-5e97f45cf4fd",
        "storage_key": "property/5700260269654016/019f14f9-ef61-739d-9cec-5e97f45cf4fd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKVeL_8Y2R4YRGC4nFgW4Oow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_10a6d3e9cb94a9f5a7d06799",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Town Green Park",
      "poi_type": "Entertainment",
      "poi_address": "2099 Lake Robbins Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "Immense open lawns highlight this public green space which features an amphitheater & a labyrinth.",
      "poi_long_description": "Immense open lawns highlight this public green space which features an amphitheater & a labyrinth.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-d6c0-745b-b731-ce97050102df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-d6c0-745b-b731-ce97050102df",
        "storage_key": "property/5700260269654016/019f14f9-d6c0-745b-b731-ce97050102df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://woodlandsevents.com/parks/town-center/town-green-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8406987068125119440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-green-park",
      "poi_latitude": "30.1617206",
      "poi_longitude": "-95.466142",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-210-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef70-75cf-9aae-891af5804c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef70-75cf-9aae-891af5804c51",
        "storage_key": "property/5700260269654016/019f14f9-ef70-75cf-9aae-891af5804c51.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdTr47Mc2R4YR0IPmQjKeq3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_5979cdfcd69c33fc01316a4d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Waterway Square",
      "poi_type": "Entertainment",
      "poi_address": "31 Waterway Square Pl, The Woodlands, TX 77380, USA",
      "poi_short_description": "Scenic park showcasing fountains and waterfalls where you can also enjoy concerts and paddle boats.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-20ae-73c1-96a5-5f38dc7a9dd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-20ae-73c1-96a5-5f38dc7a9dd8",
        "storage_key": "property/5700260269654016/019f14fc-20ae-73c1-96a5-5f38dc7a9dd8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17628338246645918111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "waterway-square",
      "poi_latitude": "30.1601821",
      "poi_longitude": "-95.4584432",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef70-75cf-9aae-891af5804c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef70-75cf-9aae-891af5804c51",
        "storage_key": "property/5700260269654016/019f14f9-ef70-75cf-9aae-891af5804c51.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfaqqL82R4YRnynDgzxwpPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_351263ecbde5b3aa60717925",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Texas TreeVentures",
      "poi_type": "Entertainment",
      "poi_address": "6464 Creekside Forest Dr, The Woodlands, TX 77389, USA",
      "poi_short_description": "High-ropes challenge course in Rob Fleming Park with multiple levels of difficulty.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-1df7-77af-b04b-eb166bf09a03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-1df7-77af-b04b-eb166bf09a03",
        "storage_key": "property/5700260269654016/019f14fc-1df7-77af-b04b-eb166bf09a03.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://texastreeventures.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4466731967841460003&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-treeventures",
      "poi_latitude": "30.1496435",
      "poi_longitude": "-95.5177122",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 281-210-2048",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM2K5_BwxR4YRI18SGg8F_T0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "adventure_sports_center"
    },
    {
      "id": "ec_26d4f3db07db07a00436de17",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Forest Oasis Waterpark",
      "poi_type": "Entertainment",
      "poi_address": "2301 N Millbend Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "Water park at a resort with 3 pools and slides, plus a lazy river, and a poolside café.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-1ead-75cc-8c60-1987009ec5e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-1ead-75cc-8c60-1987009ec5e7",
        "storage_key": "property/5700260269654016/019f14fc-1ead-75cc-8c60-1987009ec5e7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.woodlandsresort.com/activities/pool/lazy-river-and-water-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3572743890818392070&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "forest-oasis-waterpark",
      "poi_latitude": "30.1455582",
      "poi_longitude": "-95.4737963",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ164wAfk3R4YRBmCttaPvlDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "ec_785a978b8cf9d9b6fd161194",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Memorial Hermann The Woodlands Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "9250 Pinecroft Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-c596-730c-89a9-b259da1463bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-c596-730c-89a9-b259da1463bd",
        "storage_key": "property/5700260269654016/019f14f9-c596-730c-89a9-b259da1463bd.webp",
        "width": 1280,
        "height": 1080
      },
      "poi_business_url": "https://memorialhermann.org/locations/woodlands?utm_campaign=reputation-management&utm_segment=gmb_location-listing&utm_source=yext&utm_medium=organic-search",
      "poi_directions_map_url": "https://maps.google.com/?cid=4980774261720927425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-the-woodlands-medical-center",
      "poi_latitude": "30.1743163",
      "poi_longitude": "-95.4542271",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 713-897-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-efa9-725e-92c4-2374eef25e90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-efa9-725e-92c4-2374eef25e90",
        "storage_key": "property/5700260269654016/019f14f9-efa9-725e-92c4-2374eef25e90.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJgefV08Q2R4YRwcxIQM1DH0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_0fce6875b05cacc33d72abae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "AFC Urgent Care The Woodlands",
      "poi_type": "Health and Wellness",
      "poi_address": "6777 Woodlands Pkwy, The Woodlands, TX 77382, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-2565-730e-938f-74fd4b567ed4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-2565-730e-938f-74fd4b567ed4",
        "storage_key": "property/5700260269654016/019f14fc-2565-730e-938f-74fd4b567ed4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.afcurgentcare.com/the-woodlands/?utm_source=gmb&utm_medium=organic&utm_campaign=afc-the-woodlands-gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=7278223180153805232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "afc-urgent-care-the-woodlands",
      "poi_latitude": "30.1795947",
      "poi_longitude": "-95.5377605",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-429-8698",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs_qkuWgxR4YRsNkUsWtxAWU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_5cb4a8fb28091369db004141",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Texas Children's Urgent Care The Woodlands Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "17600 I-45 Suite 285 Suite 285, The Woodlands, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-2496-72f2-a70f-2058c4d0a6c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-2496-72f2-a70f-2058c4d0a6c1",
        "storage_key": "property/5700260269654016/019f14fc-2496-72f2-a70f-2058c4d0a6c1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.texaschildrens.org/locations/texas-childrens-urgent-care/woodlands-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=873335341207750799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-childrens-urgent-care-the-woodlands-campus",
      "poi_latitude": "30.2009515",
      "poi_longitude": "-95.4573514",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 936-267-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0-LXyGI3R4YRj4h7nt21Hgw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_e77a2f4def0d0de322c6e672",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3040 College Park Dr, The Woodlands, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-235d-71ca-983b-5a4e1ce18f9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-235d-71ca-983b-5a4e1ce18f9b",
        "storage_key": "property/5700260269654016/019f14fc-235d-71ca-983b-5a4e1ce18f9b.webp",
        "width": 1280,
        "height": 930
      },
      "poi_business_url": "https://www.walmart.com/store/3213-the-woodlands-tx/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1782936669426859346&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "30.209771",
      "poi_longitude": "-95.4599252",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 936-271-0755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-c775-7700-9684-f0d735a9c34c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-c775-7700-9684-f0d735a9c34c",
        "storage_key": "property/5700260269654016/019f14fc-c775-7700-9684-f0d735a9c34c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd8HXE0A3R4YRUr00VnRDvhg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_40fec7243b601aa8a0a0ce0b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3061 College Park Dr, Conroe, TX 77384, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-2419-71cc-af52-1f09531efce1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-2419-71cc-af52-1f09531efce1",
        "storage_key": "property/5700260269654016/019f14fc-2419-71cc-af52-1f09531efce1.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3061+college+park+dr-conroe-tx-77384/id=7632",
      "poi_directions_map_url": "https://maps.google.com/?cid=12071902147182191455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "30.2061703",
      "poi_longitude": "-95.4613837",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 936-271-9471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-c775-7700-9684-f0d735a9c34c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-c775-7700-9684-f0d735a9c34c",
        "storage_key": "property/5700260269654016/019f14fc-c775-7700-9684-f0d735a9c34c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ-L5Tz83R4YRX-MRDgsDiKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_0f2fb85e477ac91d9bc7b438",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "College Park Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3115 College Park Dr, Conroe, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-262e-778b-99b4-d9e316e99454.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-262e-778b-99b4-d9e316e99454",
        "storage_key": "property/5700260269654016/019f14fc-262e-778b-99b4-d9e316e99454.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.collegeparkpharmacytx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6256664498551220534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "college-park-pharmacy",
      "poi_latitude": "30.20639539999999",
      "poi_longitude": "-95.4665181",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 936-321-4011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-c775-7700-9684-f0d735a9c34c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-c775-7700-9684-f0d735a9c34c",
        "storage_key": "property/5700260269654016/019f14fc-c775-7700-9684-f0d735a9c34c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvTAzHDg3R4YRNmnxUjYj1FY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_e2d81ae4788c54677e9e7859",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "4775 W Panther Creek Dr STE A-100, The Woodlands, TX 77381, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-28e8-760a-9a4c-13f903e5dbb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-28e8-760a-9a4c-13f903e5dbb2",
        "storage_key": "property/5700260269654016/019f14fc-28e8-760a-9a4c-13f903e5dbb2.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/the-woodlands-tx-pharmacies/4775-w-panther-creek-dr-ste-a-100-the-woodlands-tx-77381/storeid=7426?WT.mc_id=LS_GOOGLE_FS_7426",
      "poi_directions_map_url": "https://maps.google.com/?cid=14609448971282000316&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "30.1673804",
      "poi_longitude": "-95.5040835",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-363-9174",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu7HL0RAxR4YRvKl1aW8wv8o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_893355d09844312585ab1b4f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Yes Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3335 College Park Dr #200, The Woodlands, TX 77384, USA",
      "poi_short_description": "Clean gym with free weights and resistance bands offers 24-hour access along with personal training.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-29a0-75f3-868f-6664d813b616.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-29a0-75f3-868f-6664d813b616",
        "storage_key": "property/5700260269654016/019f14fc-29a0-75f3-868f-6664d813b616.webp",
        "width": 1023,
        "height": 1280
      },
      "poi_business_url": "http://www.yesfitnessthewoodlands.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6073252840851334197&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yes-fitness",
      "poi_latitude": "30.20565899999999",
      "poi_longitude": "-95.470163",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHxmovnM3R4YRNWQTAkiHSFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_491705d10549d507378fe204",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4747 Research Forest Dr Ste 445, The Woodlands, TX 77381, USA",
      "poi_short_description": "Chain studio, also referred to as a gym, specializing in cardio-based classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-3449-76c7-b178-71f433a0336d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-3449-76c7-b178-71f433a0336d",
        "storage_key": "property/5700260269654016/019f14fc-3449-76c7-b178-71f433a0336d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/woodlands-texas-0753?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=2302129300454326209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "30.1843918",
      "poi_longitude": "-95.4900463",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 832-916-2115",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK77CUNgwR4YRwT-ZzGbO8h8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_1ff15fd40cd9bc893ad9f3ea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Mōtiv Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4747 Research Forest Dr Ste 100 Suite 100, The Woodlands, TX 77381, USA",
      "poi_short_description": "Fitness studio offering barre, cycle, hot yoga, trampoline, and other classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-2960-73b6-8c95-4b9a3d0073df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-2960-73b6-8c95-4b9a3d0073df",
        "storage_key": "property/5700260269654016/019f14fc-2960-73b6-8c95-4b9a3d0073df.webp",
        "width": 640,
        "height": 375
      },
      "poi_business_url": "http://motivfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7033331582089089329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mtiv-fitness",
      "poi_latitude": "30.1861854",
      "poi_longitude": "-95.4910551",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 832-499-6383",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcRR-RdgwR4YRMdH0Sc9pm2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_5a8e9fb55fe00ee0390a285f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Tapestry Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "31 E Tapestry Park Cir, The Woodlands, TX 77381, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-2b30-728b-8ae0-007fb6d9eb27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-2b30-728b-8ae0-007fb6d9eb27",
        "storage_key": "property/5700260269654016/019f14fc-2b30-728b-8ae0-007fb6d9eb27.webp",
        "width": 1280,
        "height": 1103
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4513756263400622452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tapestry-park",
      "poi_latitude": "30.18839789999999",
      "poi_longitude": "-95.470163",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef70-75cf-9aae-891af5804c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef70-75cf-9aae-891af5804c51",
        "storage_key": "property/5700260269654016/019f14f9-ef70-75cf-9aae-891af5804c51.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJF6EqJCk3R4YRdEmwGmgVpD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f68049664f8d32d919ebcb04",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Misty Dawn Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "174 Drifting Shadows Cir, Conroe, TX 77385, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-2e4e-728a-b151-241c66d8cad3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-2e4e-728a-b151-241c66d8cad3",
        "storage_key": "property/5700260269654016/019f14fc-2e4e-728a-b151-241c66d8cad3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thewoodlandstownship-tx.gov/facilities/facility/details/Misty-Dawn-Park-14",
      "poi_directions_map_url": "https://maps.google.com/?cid=10198065954644854407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "misty-dawn-park",
      "poi_latitude": "30.2230866",
      "poi_longitude": "-95.4479164",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef70-75cf-9aae-891af5804c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef70-75cf-9aae-891af5804c51",
        "storage_key": "property/5700260269654016/019f14f9-ef70-75cf-9aae-891af5804c51.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZyz7lGQ3R4YRh4acPvTOho0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_006c745a68da6d1cd795bddf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Wimberly Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Wimberly Way, Conroe, TX 77385, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-356f-74f3-ac45-1b13e073d505.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-356f-74f3-ac45-1b13e073d505",
        "storage_key": "property/5700260269654016/019f14fc-356f-74f3-ac45-1b13e073d505.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14729040748586056237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wimberly-park",
      "poi_latitude": "30.216372",
      "poi_longitude": "-95.4401685",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef70-75cf-9aae-891af5804c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef70-75cf-9aae-891af5804c51",
        "storage_key": "property/5700260269654016/019f14f9-ef70-75cf-9aae-891af5804c51.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJx_8WsXc3R4YRLbq55YUQaMw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ac0187f4fb11c3318e097f45",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Harpers Landing Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2 Blair Bridge Dr, The Woodlands, TX 77385, USA",
      "poi_short_description": "Park featuring sports facilities, a swimming pool,  playgrounds, picnic tables, a dog park & more.",
      "poi_long_description": "Park featuring sports facilities, a swimming pool,  playgrounds, picnic tables, a dog park & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-344a-729a-b6df-318c05348cfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-344a-729a-b6df-318c05348cfa",
        "storage_key": "property/5700260269654016/019f14fc-344a-729a-b6df-318c05348cfa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.thewoodlandsparks.com/Parks/Community-Parks/Parks-Directory/College-Park-Parks/Harpers-Landing-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6663604984657082329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harpers-landing-park",
      "poi_latitude": "30.2169931",
      "poi_longitude": "-95.4478088",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-210-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef70-75cf-9aae-891af5804c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef70-75cf-9aae-891af5804c51",
        "storage_key": "property/5700260269654016/019f14f9-ef70-75cf-9aae-891af5804c51.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4dpmDXo3R4YR2fcBom3heVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0a49297e476abee499cbbb60",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "The Cove Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "31 Leeward Cove Dr, The Woodlands, TX 77381, USA",
      "poi_short_description": "Little park with a lake, plus picnic areas and playgrounds, plus grills for cookouts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-4696-75c3-909d-0d9fa35d81d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-4696-75c3-909d-0d9fa35d81d7",
        "storage_key": "property/5700260269654016/019f14fc-4696-75c3-909d-0d9fa35d81d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thewoodlandstownship-tx.gov/Facilities/Facility/Details/The-Cove-Park-121?&centerLat=30.168263744685362&centerLng=-95.48159033060074&zoom=15",
      "poi_directions_map_url": "https://maps.google.com/?cid=2936995845965900391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-cove-park",
      "poi_latitude": "30.1604055",
      "poi_longitude": "-95.4889191",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef70-75cf-9aae-891af5804c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef70-75cf-9aae-891af5804c51",
        "storage_key": "property/5700260269654016/019f14f9-ef70-75cf-9aae-891af5804c51.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJT3R9BTgxR4YRZ2qYOSlOwig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_5ed2a3da9a3ddc5810705973",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "George Mitchell Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5171 Flintridge Dr, The Woodlands, TX 77381, USA",
      "poi_short_description": "This large, forested nature preserve offers a hiking trail loop, bike trails & a lake.",
      "poi_long_description": "This large, forested nature preserve offers a hiking trail loop, bike trails & a lake.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-3d34-7022-9759-46e7219a074b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-3d34-7022-9759-46e7219a074b",
        "storage_key": "property/5700260269654016/019f14fc-3d34-7022-9759-46e7219a074b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.thewoodlandstx.com/parks/george-mitchell-nature-preserve.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=11777471143174761687&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-mitchell-nature-preserve",
      "poi_latitude": "30.1629373",
      "poi_longitude": "-95.5177717",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-210-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef70-75cf-9aae-891af5804c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef70-75cf-9aae-891af5804c51",
        "storage_key": "property/5700260269654016/019f14f9-ef70-75cf-9aae-891af5804c51.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJy0LrRgoxR4YR12xY4Zr7caM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_a5e09e14ab9ddac600c8e801",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "The Recreation Center at Rob Fleming Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6464 Creekside Forest Dr, The Woodlands, TX 77389, USA",
      "poi_short_description": "Recreational area offering walking trails and picnic tables, plus a gym, and archery zone.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-4adb-7678-86d1-d1bfed4e8f63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-4adb-7678-86d1-d1bfed4e8f63",
        "storage_key": "property/5700260269654016/019f14fc-4adb-7678-86d1-d1bfed4e8f63.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.thewoodlandstownship-tx.gov/Departments/Parks-Recreation/Recreation/Recreation-Centers",
      "poi_directions_map_url": "https://maps.google.com/?cid=11211675418111350497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-recreation-center-at-rob-fleming-park",
      "poi_latitude": "30.1484295",
      "poi_longitude": "-95.51875400000002",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 281-516-7348",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt71l6ncxR4YR4ZaBCWTfl5s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_af79d45b34833b49ed248ebd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Northshore Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2505 Lake Woodlands Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "Waterfront space with playgrounds, picnic spots & a field, plus outdoor concerts & other events.",
      "poi_long_description": "Waterfront space with playgrounds, picnic spots & a field, plus outdoor concerts & other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-d6a8-71ae-85c0-f07a3653d248.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-d6a8-71ae-85c0-f07a3653d248",
        "storage_key": "property/5700260269654016/019f14f9-d6a8-71ae-85c0-f07a3653d248.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thewoodlandsparks.com/Parks/Community-Parks/Parks-Directory/Panther-Creek-Parks/Northshore-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18307336104189955607&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northshore-park",
      "poi_latitude": "30.1687385",
      "poi_longitude": "-95.4765267",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-210-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef70-75cf-9aae-891af5804c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef70-75cf-9aae-891af5804c51",
        "storage_key": "property/5700260269654016/019f14f9-ef70-75cf-9aae-891af5804c51.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Rjz4Mw2R4YRFw7tuTC5EP4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0aca4fccad741054b9441566",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Riva Row Boat House",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2101 Riva Row, The Woodlands, TX 77380, USA",
      "poi_short_description": "Lakeside park offering kayak, canoe, stand-up paddleboard, and pedal boat rentals.",
      "poi_long_description": "false",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJoWo7ELg2R4YRPLufGnjeFu0/photos/AaVGc3kpKqlQlzFSBrvSP1Tz4zg5i426h5UVL_OrWIFDlEWryuNtezNz535dWCszATZV-O81toLY3N9-CD07nitAgddW9_e6ykm2YykWv5XXouNc99JQ__BAeYX83zveGNLNvhsFlEtG0GIFgAQ3F2-dd9OIzwHvd2a_Exb71lUIzEKeZbTwVqUbjWMFELPRsZ7Yi76bNpUYM0yF8qWpPM6WT_l6-VfOQ2MPWKRCLdhNnK-OPOM4iwrHLnwWMFlncjth4uX21jB3vcfQN8p2ZhKcch8795WeewU453bCPJSQE11Ap__ACqHJPPU8dhcFXG7JmdIGLvFPqXtGgOxfazAdPXtMt4G4yKFrj2vZJFYnfYOIoOkPJNQv4Gp9W05d0p87OX_YXK2p62Ll9WkaMmdvlQ3xBYQo_Rd09lJ1YLH2CwmoH35A/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4032&maxHeightPx=2269",
      "poi_featured_image_media": null,
      "poi_business_url": "https://rivarowboathouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17084086843900672828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riva-row-boat-house",
      "poi_latitude": "30.16001769999999",
      "poi_longitude": "-95.4665433",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-210-3965",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoWo7ELg2R4YRPLufGnjeFu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_f78234ea7429ad651bd8ff4c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Lakes Edge Boat House",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1970 Hughes Landing Blvd, The Woodlands, TX 77380, USA",
      "poi_short_description": "Boat rental outfit offering canoes and kayaks for paddling on Lake Woodlands.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-5000-701a-a0cc-2839c6ce4fb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-5000-701a-a0cc-2839c6ce4fb6",
        "storage_key": "property/5700260269654016/019f14fc-5000-701a-a0cc-2839c6ce4fb6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.lakesedgeboathouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16494928151149288956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lakes-edge-boat-house",
      "poi_latitude": "30.1704917",
      "poi_longitude": "-95.4731831",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-210-2065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ01xM3c02R4YR_B3YdMLB6eQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_d394a7995c672b200f6276cc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Research Forest Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "3900 Marsico Pl, The Woodlands, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-61f1-77a9-9499-16424d539531.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-61f1-77a9-9499-16424d539531",
        "storage_key": "property/5700260269654016/019f14fc-61f1-77a9-9499-16424d539531.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://woodlandstransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15778184797064041952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "research-forest-park--ride",
      "poi_latitude": "30.1927936",
      "poi_longitude": "-95.4748177",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 936-273-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKSOpKuM3R4YR4JV4_Xlf99o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_98405d9d346cc6f0a9b74deb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Sterling Ridge Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "8001 McBeth Way, The Woodlands, TX 77382, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-5700-75d9-88cc-8020627724e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-5700-75d9-88cc-8020627724e3",
        "storage_key": "property/5700260269654016/019f14fc-5700-75d9-88cc-8020627724e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thewoodlandstownship-tx.gov/Departments/Transportation",
      "poi_directions_map_url": "https://maps.google.com/?cid=2548114769123178756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sterling-ridge-park--ride",
      "poi_latitude": "30.1812573",
      "poi_longitude": "-95.5592182",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-363-1325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqj4wR4YRBHmDzOG4XCM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_7d537cde2ae2611d3b7f53c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Sawdust Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "701 Westridge Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-5127-75de-9cd7-4d1976a6c635.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-5127-75de-9cd7-4d1976a6c635",
        "storage_key": "property/5700260269654016/019f14fc-5127-75de-9cd7-4d1976a6c635.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thewoodlandstownship-tx.gov/Departments/Transportation",
      "poi_directions_map_url": "https://maps.google.com/?cid=18193597785316610762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sawdust-park--ride",
      "poi_latitude": "30.1203476",
      "poi_longitude": "-95.4537629",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-363-0882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpx6oJzw0R4YRylIhvMqkfPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_afd743f5d111f25b0614c345",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Waterways Trolley Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "Waterway Square Pl, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-63dc-7478-8042-88fcd65cbf7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-63dc-7478-8042-88fcd65cbf7b",
        "storage_key": "property/5700260269654016/019f14fc-63dc-7478-8042-88fcd65cbf7b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thewoodlandstownship-tx.gov/358/Waterway-Trolleys",
      "poi_directions_map_url": "https://maps.google.com/?cid=16711490075715991407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "waterways-trolley-stop",
      "poi_latitude": "30.1603077",
      "poi_longitude": "-95.4582115",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-210-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxxOVkr82R4YRb3eEvq4j6-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_e580c47ceb185af54132bdb7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Waterways Trolley Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "Waterway Square Pl, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-71fe-7485-834c-5800cf377645.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-71fe-7485-834c-5800cf377645",
        "storage_key": "property/5700260269654016/019f14fc-71fe-7485-834c-5800cf377645.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thewoodlandstownship-tx.gov/358/Waterway-Trolleys",
      "poi_directions_map_url": "https://maps.google.com/?cid=16711490075715991407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "waterways-trolley-stop",
      "poi_latitude": "30.1603077",
      "poi_longitude": "-95.4582115",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-210-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxxOVkr82R4YRb3eEvq4j6-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_60f5744cbb7e86763493ee3e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Riva Row Boat House",
      "poi_type": "Transportation & Transit",
      "poi_address": "2101 Riva Row, The Woodlands, TX 77380, USA",
      "poi_short_description": "Lakeside park offering kayak, canoe, stand-up paddleboard, and pedal boat rentals.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-2dfb-765d-911a-bc16d0101a72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-2dfb-765d-911a-bc16d0101a72",
        "storage_key": "property/5700260269654016/019f14fc-2dfb-765d-911a-bc16d0101a72.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://rivarowboathouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17084086843900672828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riva-row-boat-house",
      "poi_latitude": "30.16001769999999",
      "poi_longitude": "-95.4665433",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-210-3965",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoWo7ELg2R4YRPLufGnjeFu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_afef575de67ce3c0ddd6e3a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Town Centre Garage Marriot Hotel Guest Free parking",
      "poi_type": "Transportation & Transit",
      "poi_address": "Six Pines Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-6bb8-706a-865e-7fd6d4ef420b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-6bb8-706a-865e-7fd6d4ef420b",
        "storage_key": "property/5700260269654016/019f14fc-6bb8-706a-865e-7fd6d4ef420b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17956210911674636896&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-centre-garage-marriot-hotel-guest-free-parking",
      "poi_latitude": "30.1612063",
      "poi_longitude": "-95.4625729",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-c763-756a-a75e-dac20b0e9217.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-c763-756a-a75e-dac20b0e9217",
        "storage_key": "property/5700260269654016/019f14fc-c763-756a-a75e-dac20b0e9217.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJeVy6pjU3R4YRYBpcJrBGMfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_garage"
    },
    {
      "id": "ec_4592c78362f6c2f6cc97dc9e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "George Bush Intercontinental Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2800 N Terminal Rd, Houston, TX 77032, USA",
      "poi_short_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_long_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-80d5-703c-8af7-85f785913ff7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-80d5-703c-8af7-85f785913ff7",
        "storage_key": "property/5700260269654016/019f14fc-80d5-703c-8af7-85f785913ff7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fly2houston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11296915713098302001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-bush-intercontinental-airport",
      "poi_latitude": "29.9931058",
      "poi_longitude": "-95.3416255",
      "poi_miles_from_property": "29.4 mi",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "2 hours 25 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 281-230-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-c767-7427-81d5-ee3dae28d8db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-c767-7427-81d5-ee3dae28d8db",
        "storage_key": "property/5700260269654016/019f14fc-c767-7427-81d5-ee3dae28d8db.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1VD2SO0QIYRMcLAyPy0xpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_4c55b897e9729fb6eb76903e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Lakes Edge Boat House",
      "poi_type": "Transportation & Transit",
      "poi_address": "1970 Hughes Landing Blvd, The Woodlands, TX 77380, USA",
      "poi_short_description": "Boat rental outfit offering canoes and kayaks for paddling on Lake Woodlands.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-5000-701a-a0cc-2839c6ce4fb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-5000-701a-a0cc-2839c6ce4fb6",
        "storage_key": "property/5700260269654016/019f14fc-5000-701a-a0cc-2839c6ce4fb6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.lakesedgeboathouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16494928151149288956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lakes-edge-boat-house",
      "poi_latitude": "30.1704917",
      "poi_longitude": "-95.4731831",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-210-2065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ01xM3c02R4YR_B3YdMLB6eQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_82192b1d5727b317a6a9834f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Anadarko Tower",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Anadarko Tower, 1201 Lake Robbins Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-8059-7345-a988-75f7ba1f5b1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-8059-7345-a988-75f7ba1f5b1f",
        "storage_key": "property/5700260269654016/019f14fc-8059-7345-a988-75f7ba1f5b1f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10774654922707532628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anadarko-tower",
      "poi_latitude": "30.1605767",
      "poi_longitude": "-95.4527632",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTa_5upQ2R4YRVHtlzZBDh5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "premise"
    },
    {
      "id": "ec_4a425884e361629b0a77a216",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Anadarko Hackett Tower",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9950 Woodloch Forest Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-8573-719f-ad0b-67b388b0acee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-8573-719f-ad0b-67b388b0acee",
        "storage_key": "property/5700260269654016/019f14fc-8573-719f-ad0b-67b388b0acee.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2028790294522164981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anadarko-hackett-tower",
      "poi_latitude": "30.1604709",
      "poi_longitude": "-95.4553668",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc6W_SpU2R4YR9fbAHAa2Jxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "ec_54a44494829f5d8a6ec88394",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Memorial Hermann The Woodlands Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9250 Pinecroft Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-c596-730c-89a9-b259da1463bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-c596-730c-89a9-b259da1463bd",
        "storage_key": "property/5700260269654016/019f14f9-c596-730c-89a9-b259da1463bd.webp",
        "width": 1280,
        "height": 1080
      },
      "poi_business_url": "https://memorialhermann.org/locations/woodlands?utm_campaign=reputation-management&utm_segment=gmb_location-listing&utm_source=yext&utm_medium=organic-search",
      "poi_directions_map_url": "https://maps.google.com/?cid=4980774261720927425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-the-woodlands-medical-center",
      "poi_latitude": "30.1743163",
      "poi_longitude": "-95.4542271",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 713-897-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-efa9-725e-92c4-2374eef25e90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-efa9-725e-92c4-2374eef25e90",
        "storage_key": "property/5700260269654016/019f14f9-efa9-725e-92c4-2374eef25e90.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJgefV08Q2R4YRwcxIQM1DH0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_db0c289dc6401ebb761d205b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Houston Methodist The Woodlands Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17201 I-45, Conroe, TX 77385, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-cef7-727d-b391-e167a94e1959.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-cef7-727d-b391-e167a94e1959",
        "storage_key": "property/5700260269654016/019f14f9-cef7-727d-b391-e167a94e1959.webp",
        "width": 1140,
        "height": 560
      },
      "poi_business_url": "https://www.houstonmethodist.org/locations/the-woodlands/?utm_source=gmb&utm_medium=organic&utm_campaign=all_location_gmb&utm_content=website-click",
      "poi_directions_map_url": "https://maps.google.com/?cid=12078372465785096765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-methodist-the-woodlands-hospital",
      "poi_latitude": "30.20581229999999",
      "poi_longitude": "-95.4535176",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 936-270-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-efa9-725e-92c4-2374eef25e90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-efa9-725e-92c4-2374eef25e90",
        "storage_key": "property/5700260269654016/019f14f9-efa9-725e-92c4-2374eef25e90.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJHVog23DAQIYRPcr6f8P_nqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_fd0bd0a29f8c47d6602307ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Texas Children's Hospital The Woodlands - Outpatient Services",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17580 I-45, The Woodlands, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-9c74-7785-adab-632c3b47160d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-9c74-7785-adab-632c3b47160d",
        "storage_key": "property/5700260269654016/019f14fc-9c74-7785-adab-632c3b47160d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texaschildrens.org/locations/texas-childrens-hospital/woodlands-outpatient-services",
      "poi_directions_map_url": "https://maps.google.com/?cid=7899597091832676584&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-childrens-hospital-the-woodlands---outpatient-services",
      "poi_latitude": "30.2013453",
      "poi_longitude": "-95.4574926",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 936-267-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL9wSB8A2R4YR6EBlf7MBoW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_caba09624dc35222137431c4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Chevron Phillips Chemical Company LP",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9500 Lakeside Blvd, The Woodlands, TX 77381, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-87cf-77cf-928d-5a24b360e7b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-87cf-77cf-928d-5a24b360e7b3",
        "storage_key": "property/5700260269654016/019f14fc-87cf-77cf-928d-5a24b360e7b3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cpchem.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8985774748554964679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chevron-phillips-chemical-company-lp",
      "poi_latitude": "30.1721239",
      "poi_longitude": "-95.4746216",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 832-813-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi2HINLk2R4YRxy5Lb4bis3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_d462f1f22ca92a10ec498ecd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Huntsman Advanced Materials",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8600 Gosling Rd, The Woodlands, TX 77381, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-a204-719e-9f8a-38cf4c6a11b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-a204-719e-9f8a-38cf4c6a11b5",
        "storage_key": "property/5700260269654016/019f14fc-a204-719e-9f8a-38cf4c6a11b5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.huntsman.com/advanced_materials/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5871671960520385530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "huntsman-advanced-materials",
      "poi_latitude": "30.1880112",
      "poi_longitude": "-95.4835591",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-719-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3YtoodYwR4YR-mNw5IlefFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_cbf45915baf13712d3d5eba6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Baker Hughes",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9110 Grogans Mill Rd, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.bakerhughes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3977024958519619476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baker-hughes",
      "poi_latitude": "30.1731608",
      "poi_longitude": "-95.464037",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-363-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPQLIF9s2R4YRlK9s6yA7MTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_0c67b1fce826de1362c36061",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "Lone Star College System Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5000 Research Forest Dr, The Woodlands, TX 77381, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-a5ef-72a9-b58f-2123229f1e52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-a5ef-72a9-b58f-2123229f1e52",
        "storage_key": "property/5700260269654016/019f14fc-a5ef-72a9-b58f-2123229f1e52.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lonestar.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11872299323758135843&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lone-star-college-system-office",
      "poi_latitude": "30.187545",
      "poi_longitude": "-95.4885621",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 832-813-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-efb9-74ef-9aa7-557cfa8cf35c",
        "storage_key": "property/5700260269654016/019f14f9-efb9-74ef-9aa7-557cfa8cf35c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz5LplNkwR4YRI8q2M1XhwqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_45171a549a3962866878cbe6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "poi_name": "ExxonMobil Houston Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "22777 Springwoods Village Pkwy, Spring, TX 77389, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14fc-9a7f-702f-9970-54af69f351a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-9a7f-702f-9970-54af69f351a6",
        "storage_key": "property/5700260269654016/019f14fc-9a7f-702f-9970-54af69f351a6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://corporate.exxonmobil.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4652161626967610876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "exxonmobil-houston-campus",
      "poi_latitude": "30.1032818",
      "poi_longitude": "-95.4463252",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-582-3645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ef77-76fd-83b4-467ef3b5ca03",
        "storage_key": "property/5700260269654016/019f14f9-ef77-76fd-83b4-467ef3b5ca03.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwbXzI1A0R4YR_JUb_VnMj0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_b6991be5-ce4a-476d-af9d-377ec0e00993",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e031d3bd-d216-40a1-88ad-ddfee82230bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_6f0a0db6-9180-41d5-b128-d1a19f5c4e77",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f4a0d23d-7cfd-42e1-aee5-411804e7f5a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_4dd3273b-f8b1-4f51-9a10-7cfdb63e5c03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "custom_79cacce0-947e-4712-935c-67fc90b3954b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_11b7257e-8848-472d-9918-96eaf1a7080c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_8b20a78c-a305-41e2-9e4b-a064c5935359",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "rating": "5.0",
      "name": "Eugene Bailey",
      "text": "I’ve had a wonderful experience living at Stone Creek Apartments over the last year. From day one, the customer service has been nothing short of outstanding. The entire staff has always been professional, friendly, and genuinely willing to help whenever I’ve had questions or needed assistance.\n\nThe maintenance team is prompt and efficient, and any issues are handled quickly and with care. The property is well-maintained, clean, and provides a comfortable place to call home.\n\nWhat really stands out is the level of respect and professionalism shown by everyone in the office especially Brandon. Brandon goes above and beyond to make residents feel valued, which is something you don’t find everywhere these days.\n\nOver the past year, I’ve truly enjoyed my time here and have appreciated the positive atmosphere and excellent management. I would highly recommend Brandon & Stone Creek Apartments to anyone looking for a place that combines great living with exceptional customer service.",
      "date": "2026-06-04",
      "title": ""
    },
    {
      "id": "custom_87f34aaf-066f-4dd7-817f-cc5ed9717cea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "rating": "5.0",
      "name": "C Conley",
      "text": "Truly Grateful\n\nI want to start by saying how welcoming and helpful the team was throughout the entire process. From the beginning, the application was quick and easy, and Brandon was there every step of the way, making everything smooth and stress-free.\n\nAfter moving into my apartment, I was initially very excited. However, I did run into a serious issue with a German roach infestation. It was significant enough that I had to stay at my girlfriend’s apartment for about a week while trying to figure out what to do.\n\nOne night, I returned to find roaches in every room, and I knew I couldn’t continue living there under those conditions. I reached out to Julie, and she responded immediately. By the very next day, she had arranged a transfer to a new unit. She also helped with credits and truly went above and beyond to make things right.\n\nI’ve now been in my new unit for two weeks, and I’m happy to say it’s completely roach-free. Brandon and Julie both stepped up when I needed help the most, and they genuinely cared about resolving the situation.\n\nI’m beyond grateful for their support and professionalism. Thank you both for turning a difficult situation into a positive experience.",
      "date": "2026-03-31",
      "title": ""
    },
    {
      "id": "custom_506691bd-ec45-487c-b908-0e4a563b7d7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "rating": "5.0",
      "name": "H “SocialNomad” M",
      "text": "Stone Creek Woodlands has truly been a wonderful place to live, and the overall sense of community here really sets it apart. The property is well maintained, peaceful, and welcoming, making it easy to feel at home. From the landscaping to the shared spaces, it’s clear that a lot of care goes into keeping the community comfortable and enjoyable for residents.\n\nI especially want to recognize Brandon Serrano, the Assistant Community Manager, for the outstanding job he does. Brandon is consistently professional, approachable, and responsive. Any time I’ve had a question or concern, he’s handled it efficiently and with genuine care, making sure things are resolved in a timely manner. His communication skills and attention to detail truly make a difference in the day-to-day living experience.\n\nIt’s rare to find a community where management is so actively involved and invested in resident satisfaction, and Brandon is a big reason for that. His dedication and positive attitude reflect extremely well on Stone Creek Woodlands as a whole. I would highly recommend this community to anyone looking for a place where residents are valued and management goes above and beyond.",
      "date": "2026-01-22",
      "title": ""
    },
    {
      "id": "custom_b2359ae5-581c-4fad-8c67-db511acf26a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "rating": "5.0",
      "name": "Kanishka G",
      "text": "Awesome service! We’ve been with them for 12 months, and everything has been great. Whenever we have questions or if anything comes up, they respond quickly and solve the issue right away. Highly recommended!",
      "date": "2026-06-01",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_316edde4d7fc6c962d03655f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f14c3-7f01-705e-a6bb-c3286dc1d6e5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-7f01-705e-a6bb-c3286dc1d6e5",
        "storage_key": "property/5700260269654016/019f14c3-7f01-705e-a6bb-c3286dc1d6e5.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Stone Creek at the Woodlands - Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/WIqlfzrQFDw"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-f004-77cd-a5e3-90137b61b5aa",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "stone-creek-at-the-woodlands",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016"
    },
    {
      "lead_collector_id": "0198aa45-f068-7452-8791-7162c95ac410",
      "lead_source": "FACEBOOK_ADS",
      "name": "stone-creek-at-the-woodlands",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016"
    },
    {
      "lead_collector_id": "0198aa45-f0cc-76a8-9a62-adff2816fcef",
      "lead_source": "LANDING_PAGE",
      "name": "stone-creek-at-the-woodlands",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "page_item_url": "luxury-apartments-with-pool-the-woodlands-tx-780",
      "search_query": "luxury apartments with pool The Woodlands TX",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in The Woodlands",
      "h2_subtitle": "Experience luxury living at Stone Creek at The Woodlands. Explore our apartments, featuring stunning pools and exceptional amenities today.",
      "page_copy": "Discover the epitome of luxury at Stone Creek at The Woodlands, where our luxury apartments with pool The Woodlands TX provide a serene escape with resort-style amenities. Choose from a range of spacious one, two, or three-bedroom floor plans, each designed for comfort and style. Dive into our beach-entry swimming pool or relax on the sundeck, soaking up the Texas sun. \n\nInside, your new home awaits with features like a chef's kitchen, tile floors, and heating for those cooler evenings. Our gated community also includes a fitness center and a fun dog park for your furry friends. Located in Montgomery County, live in luxury while staying connected to everything The Woodlands has to offer. Prepare to elevate your lifestyle at Stone Creek at The Woodlands.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f6c10-bd33-7612-a674-6671e724845d.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a dark gray sofa, two accent chairs, a coffee table, and modern art.",
        "public_id": "019f6c10-bd33-7612-a674-6671e724845d",
        "storage_key": "property/5700260269654016/019f6c10-bd33-7612-a674-6671e724845d.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool at The Woodlands",
      "seo_description": "Explore luxury apartments with pool at Stone Creek, The Woodlands, TX. Enjoy top amenities and a perfect location. Find your new home today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-montgomery-county-68",
      "search_query": "fitness center apartments Montgomery County",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Montgomery County",
      "h2_subtitle": "Stone Creek at The Woodlands offers premier apartments featuring an on-site fitness center and stylish living in Montgomery County.",
      "page_copy": "Achieve your health goals at Stone Creek at The Woodlands, where fitness center apartments Montgomery County offer more than just a place to live. Our residents enjoy access to a state-of-the-art fitness center as part of our suite of amenities tailored to promote an active lifestyle. \n\nChoose from a selection of one, two, or three-bedroom apartments, each featuring a chef's kitchen and modern conveniences. Beyond the fitness center, dive into our refreshing pools or take leisurely strolls around our dog park. Situated in the vibrant community of The Woodlands, our location places you in the heart of Montgomery County with easy access to local shopping, dining, and entertainment. Welcome home to active living at Stone Creek.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f6c10-bd33-7612-a674-6671e724845d.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a dark gray sofa, two accent chairs, a coffee table, and modern art.",
        "public_id": "019f6c10-bd33-7612-a674-6671e724845d",
        "storage_key": "property/5700260269654016/019f6c10-bd33-7612-a674-6671e724845d.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center Montgomery County",
      "seo_description": "Discover Stone Creek at The Woodlands for top fitness center apartments in Montgomery County. Enjoy modern amenities and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "page_item_url": "gated-community-apartments-77384-340",
      "search_query": "gated community apartments 77384",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments in 77384",
      "h2_subtitle": "Discover safety and luxury at Stone Creek at The Woodlands, a gated community offering spacious apartments in the 77384 area.",
      "page_copy": "Experience peace of mind and luxury living at Stone Creek at The Woodlands, where our gated community apartments 77384 combine security with sophisticated living. Our community offers a selection of one, two, or three-bedroom floor plans, designed with your comfort in mind and equipped with modern amenities including a chef's kitchen and tile floors.\n\nEnjoy the resort-style features like our inviting beach-entry swimming pool and sundeck. As a gated community, you can relax knowing you have the added benefit of controlled access, creating an exclusive and secure environment. Located conveniently in The Woodlands, TX, embrace a tranquil lifestyle within reach of vibrant local attractions, all nestled in the heart of Montgomery County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f6c10-bd33-7612-a674-6671e724845d.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a dark gray sofa, two accent chairs, a coffee table, and modern art.",
        "public_id": "019f6c10-bd33-7612-a674-6671e724845d",
        "storage_key": "property/5700260269654016/019f6c10-bd33-7612-a674-6671e724845d.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments in The Woodlands 77384",
      "seo_description": "Explore Stone Creek's gated community apartments in 77384. Enjoy secure, luxury living in The Woodlands with top amenities and convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-with-dog-park-the-woodlands-994",
      "search_query": "pet friendly apartments with dog park The Woodlands",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park",
      "h2_subtitle": "Stone Creek at The Woodlands is the perfect home for you and your pets, offering spacious apartments and a dedicated dog park.",
      "page_copy": "Welcome to Stone Creek at The Woodlands, where our pet-friendly apartments with dog park The Woodlands are tailored for your furry friends. Our community embraces pets, providing not only spacious floor plans but also a dedicated dog park where pets can play and make new friends.\n\nChoose from a variety of apartment layouts, each featuring modern amenities like a chef's kitchen. Residents enjoy resort-style pools and a sundeck, creating a complete living experience. Located in The Woodlands, our community offers a vibrant neighborhood with close access to Montgomery County's finest attractions. Stone Creek at The Woodlands is more than just a home; it's the perfect place for you and your pets to thrive.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f6c10-bd33-7612-a674-6671e724845d.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a dark gray sofa, two accent chairs, a coffee table, and modern art.",
        "public_id": "019f6c10-bd33-7612-a674-6671e724845d",
        "storage_key": "property/5700260269654016/019f6c10-bd33-7612-a674-6671e724845d.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in The Woodlands",
      "seo_description": "Discover pet-friendly apartments with a dog park in The Woodlands at Stone Creek. Perfect for you and your furry friends with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-college-park-dr-183",
      "search_query": "in unit laundry apartments near College Park Dr",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments Near College Park Dr",
      "h2_subtitle": "Enjoy the convenience of in-unit laundry at Stone Creek at The Woodlands, located just off College Park Dr.",
      "page_copy": "Experience the ultimate convenience at Stone Creek at The Woodlands, offering in-unit laundry apartments near College Park Dr. Our community provides residents with the luxury of doing laundry at home, freeing up more time for you to enjoy the exceptional amenities we provide.\n\nSelect from our spacious one, two, or three-bedroom apartments, each boasting modern features such as a chef's kitchen. Beyond the luxury inside, indulge in our outdoor amenities like the beach-entry pool and sundeck. Our prime location near College Park Dr in The Woodlands places you close to shopping, dining, and entertainment in Montgomery County. Stone Creek is where comfort meets convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f6c10-bd33-7612-a674-6671e724845d.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a dark gray sofa, two accent chairs, a coffee table, and modern art.",
        "public_id": "019f6c10-bd33-7612-a674-6671e724845d",
        "storage_key": "property/5700260269654016/019f6c10-bd33-7612-a674-6671e724845d.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments Near College Park Dr",
      "seo_description": "Discover in-unit laundry apartments at Stone Creek near College Park Dr. Enjoy modern convenience and a vibrant lifestyle in The Woodlands.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-the-woodlands-tx-136",
      "search_query": "one bedroom apartments in The Woodlands TX",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in The Woodlands, TX",
      "h2_subtitle": "Explore the spacious one-bedroom apartments at Stone Creek, located in The Woodlands, TX, where comfort meets elegance.",
      "page_copy": "Discover the charm and convenience of the one-bedroom apartments in The Woodlands, TX, at Stone Creek. Our community offers a thoughtfully designed living space that caters to your lifestyle needs with modern features like a chef's kitchen and ample storage. \n\nResidents enjoy a selection of luxurious amenities including a beach-entry pool, sundeck, and access to our fitness center, making Stone Creek not just a home, but a lifestyle. Ideally situated in The Woodlands, you’ll relish the proximity to local shopping and dining, all while residing in a serene, gated community. Experience elevated living in Montgomery County at Stone Creek.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f6c10-bd33-7612-a674-6671e724845d.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a dark gray sofa, two accent chairs, a coffee table, and modern art.",
        "public_id": "019f6c10-bd33-7612-a674-6671e724845d",
        "storage_key": "property/5700260269654016/019f6c10-bd33-7612-a674-6671e724845d.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in The Woodlands, TX",
      "seo_description": "Find spacious one-bedroom apartments in The Woodlands, TX, at Stone Creek. Enjoy modern amenities and a vibrant lifestyle today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-in-montgomery-county-966",
      "search_query": "two bedroom apartments in Montgomery County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Montgomery County",
      "h2_subtitle": "Discover spacious two-bedroom apartments at Stone Creek, perfectly situated in Montgomery County, offering comfort and modern amenities.",
      "page_copy": "Welcome to Stone Creek at The Woodlands, where you’ll find ideal two-bedroom apartments in Montgomery County. Our community provides spacious floor plans that seamlessly blend comfort with functionality, featuring a chef's kitchen and modern interior design. \n\nResidents enjoy exclusive community amenities such as a beach-entry swimming pool, fitness center, and a beautiful sundeck. The pet-friendly environment with a dog park is perfect for animal lovers. Located in The Woodlands, our community offers easy access to shopping, dining, and entertainment options, making it the perfect place to call home. Experience quality living in the heart of Montgomery County at Stone Creek.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f6c10-bd33-7612-a674-6671e724845d.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a dark gray sofa, two accent chairs, a coffee table, and modern art.",
        "public_id": "019f6c10-bd33-7612-a674-6671e724845d",
        "storage_key": "property/5700260269654016/019f6c10-bd33-7612-a674-6671e724845d.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Montgomery County",
      "seo_description": "Explore two-bedroom apartments in Montgomery County at Stone Creek. Enjoy modern amenities and a lively community in The Woodlands.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5700260269654016",
      "source": "custom",
      "page_item_url": "three-bedroom-floor-plans-near-77384-542",
      "search_query": "three bedroom floor plans near 77384",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Floor Plans Near 77384",
      "h2_subtitle": "Explore spacious three-bedroom floor plans at Stone Creek, conveniently located near the 77384 area, offering ample space and modern amenities.",
      "page_copy": "Discover the perfect home with our expansive three-bedroom floor plans near 77384 at Stone Creek in The Woodlands. Our thoughtfully designed apartments offer ample living space, perfect for families or those needing extra room, complete with modern features like a chef's kitchen and tile floors.\n\nLocated in the vibrant area of The Woodlands, our community provides residents access to top amenities including a beach-entry pool, fitness center, and a sundeck for relaxing afternoons. Experience the comfort of our gated community and the convenience of nearby shopping and dining options. Stone Creek offers a remarkable blend of style, comfort, and location in Montgomery County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019f6c10-bd33-7612-a674-6671e724845d.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a dark gray sofa, two accent chairs, a coffee table, and modern art.",
        "public_id": "019f6c10-bd33-7612-a674-6671e724845d",
        "storage_key": "property/5700260269654016/019f6c10-bd33-7612-a674-6671e724845d.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Floor Plans Near 77384",
      "seo_description": "Discover spacious three-bedroom floor plans near 77384 at Stone Creek. Enjoy convenient access and modern amenities in The Woodlands.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2194"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376471607"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a48\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a48\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4770447"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KCC2RK3"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://stonecreek.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443276571"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/zlpo5ng4vg4"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/ad8e9ad9-81de-413f-9a9a-fc1418b83bec"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "832-240-2681"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlNIY3lWYzNwQmIvZnV5MXF0Q0lIalE9PSIsInZhbHVlIjoiZ2gzcDJDSnp2ZnZMM1B3c1ZMUlIzQT09IiwibWFjIjoiZDAxMjk4OTM0N2ZlMzhkZWQxMWQ5ZWI2MjJjNGRlNWJmMTliYTRkZWRmZmJhNmI5OGM5OGZjNDk4ZTVkMzlhMCJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2194",
  "custom_repli_id": "2376471607",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a48\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a48\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4770447",
  "custom_google_gtm_id": "GTM-KCC2RK3",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_betterbot_script": "<script src=\"https://stonecreek.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443276571",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/zlpo5ng4vg4",
  "custom_self_guided_tour_url": "https://selftournow.com/property/ad8e9ad9-81de-413f-9a9a-fc1418b83bec",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "832-240-2681",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlNIY3lWYzNwQmIvZnV5MXF0Q0lIalE9PSIsInZhbHVlIjoiZ2gzcDJDSnp2ZnZMM1B3c1ZMUlIzQT09IiwibWFjIjoiZDAxMjk4OTM0N2ZlMzhkZWQxMWQ5ZWI2MjJjNGRlNWJmMTliYTRkZWRmZmJhNmI5OGM5OGZjNDk4ZTVkMzlhMCJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "4be367bf-f61d-4488-bef7-9b6d2fec0780",
  "custom_audioeye_site_hash": "c72d93d9569bd04386d4a9b2bffb5054"
};

export const generatedAt = '2026-11-03T20:32:43.331Z';
